<template>
  <v-container fluid pa-0>
        <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="Search_data"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top:7px;color:#fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>
     <filter-component :json_data ="form_filter_data" v-on:set="onCloseFormDialog" />
       <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>
     <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter" >
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>
    <v-layout row wrap hidden-xs-only>
      <!-- <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex> -->
    </v-layout>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- command box -->
      <v-flex md12 sm12 xs12 ma-2>
        <v-layout row wrap>
          <v-flex md3 xs12 px-1>
             <v-text-field
              label="ค้นหา..."
              v-model="Search_data"
              @input="searchProcess()"
              append-icon="search"
              style="margin-bottom: 0px;"
            ></v-text-field>
          </v-flex>
          <v-flex md3 xs12 px-1>
            <v-select
              :items="startmonth"
              :item-text="$t('txt')"
              item-value="val"
              :label="$t('fromMonth')"
              v-model="Start_month"
              @change="selectChoice()"
            >
              <template slot="item" slot-scope="{item}">
                <div>{{ $t(item.txt) }}</div>
              </template>
            </v-select>
          </v-flex>
           <v-flex md3 xs12 px-1>
            <v-select
              :items="endmonth"
              :item-text="$t('txt')"
              item-value="val"
              :label="$t('toMonth')"
              v-model="End_month"
              @change="selectChoice()"
            >
              <template slot="item" slot-scope="{item}">
                <div>{{ $t(item.txt) }}</div>
              </template>
            </v-select>
          </v-flex>
          <v-flex md3 xs12 px-1  >
                    <v-select
                    v-model="year"
                    :items="years"
                    :label="$t('Taxyear')"
                    item-text="name"
                    item-value="name"
                  ></v-select>
              </v-flex>
          <v-flex md12 sm12 xs12 class="hidden-sm-and-up">
          <v-btn slot="activator" color="primary" dark fixed bottom right fab @click="buttondocDialog=true">
            <v-icon>apps</v-icon>
          </v-btn>
      </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md12 sm12 xs12 ma-2>
        
        <v-layout row wrap >
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="success" @click="process()" v-if="check_permission == true || admin == 'true'">
              <v-icon class="pr-2" size="16">fa-spinner</v-icon>
              <span>{{$t('processor')}}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1 class="hidden-xs-only " v-if="check_permission == true || admin == 'true'">
            <v-btn block color="primary" @click="showCreateDocDialog()">
              <v-icon class="pr-2" size="16">fa-plus</v-icon>
              <span>{{$t('Createpaymentdocuments')}}</span>
            </v-btn>
          </v-flex>

          <v-flex md2 sm6 xs12 px-1 class="hidden-xs-only " v-if="buttonlist == 1 && (check_permission == true || admin == 'true')">
            <v-btn block color="info" @click="checkbutton(1,'downloadexcel')">
              <v-icon class="pr-2" size="16">fa-file-excel</v-icon>
              <span>{{$t('Exportexcel')}}</span>
            </v-btn>
          </v-flex>
          <!--  <v-flex md2 xs6 px-1>
            <v-btn block color="primary" >
              <v-icon class="pr-2" size="16">fa-copy</v-icon>
              <span>open in sheet</span>
            </v-btn>
          </v-flex>-->

          <v-flex md2 sm6 xs12 px-1 class="hidden-xs-only " v-if="buttonlist == 1 && (check_permission == true || admin == 'true')">
            <v-btn block color="primary" @click="checkbutton(1,'doCopyTable')">
              <v-icon class="pr-2" size="16">fa-copy</v-icon>
              <span>{{$t('copy')}}</span>
            </v-btn>
          </v-flex>
          <!--  <v-flex md2 xs6 px-1>
            <v-btn block color="info">
              <v-icon class="pr-2" size="16">fa-print</v-icon>
              <span>พิมพ์รายงาน</span>
            </v-btn>
          </v-flex>-->
          <!-- <v-flex md2 sm6 xs12 px-10 v-if="buttonlist == 0">
            <v-btn block color="warning" style="visibility:hidden" >
              <v-icon class="pr-2" size="16">fa-info</v-icon>
              <span>{{$t('showdetails')}}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-10 v-else>
            <v-btn block color="warning">
              <v-icon class="pr-2" size="16">fa-info</v-icon>
              <span>{{$t('showdetails')}}</span>
            </v-btn>
          </v-flex> -->
          <v-flex md2 sm6 xs12 px-1 v-if="buttonlist == 0 && (check_permission == true || admin == 'true')">
            <v-btn
              block
              dark
              color="deep-purple"
              @click="filterDialog = true"
              style="visibility:hidden"
            >
              <v-icon class="pr-2" size="16">fa-filter</v-icon>
              <span>{{$t('displayoptions')}}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1 v-if="buttonlist == 1 && (check_permission == true || admin == 'true')">
            <v-btn block dark color="deep-purple" @click="filterDialog = true">
              <v-icon class="pr-2" size="16">fa-filter</v-icon>
              <span>{{$t('displayoptions')}}</span>
            </v-btn>
          </v-flex>
        </v-layout>


        <v-layout row wrap class="hidden-xs-only content">
          <v-flex xs12 v-if="check_permission == true || admin == 'true'">
            <v-btn dark v-if="buttonlist == 1 " color="blue-grey darken-2" @click="checkbutton(0,'display')">
              <v-icon dark>fa-list</v-icon>
            </v-btn>
             <v-btn dark v-else color="light-blue accent-4" @click="checkbutton(0,'display')">
              <v-icon dark>fa-list</v-icon>
            </v-btn>
            <v-btn dark v-if="buttonlist == 0 " color="blue-grey darken-2" @click="checkbutton(1,'display')">
              <v-icon dark>fa-table</v-icon>
            </v-btn>
             <v-btn dark v-else color="light-blue accent-4" @click="checkbutton(1,'display')">
              <v-icon dark>fa-table</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-layout row wrap v-if="buttonlist == 0 && (check_permission == true || admin == 'true')">
            <v-container
              fluid
              pt-3
              style="border-right:0px;border-left:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;"
            >
              <v-layout row wrap>
                <v-flex md12 sm12 xs12 class="hidden-sm-and-up">
                  <!-- ไม่แสดงขนาดกลางและขนาดใหญ๋ -->
                  <v-expansion-panel expand>
                    <v-expansion-panel-content
                      style="background-color:#ffffff;margin:0px;"
                      v-for="(item,i) in  table_datalist_resign"
                      :key="i"
                      expand-icon
                    >
                      <div slot="header">
                        <v-card class="coco-box-shadow">
                          <v-layout align-center justify-center row fill-height wrap>
                            <v-flex lg1 md1 sm2 xs3 text-xs-center>
                              <v-avatar
                                v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                                :size="64"
                                color="teal"
                              >
                                <span class="white--text headline">{{item.nickName}}</span>
                              </v-avatar>

                              <Empimage
                                v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                                :json_data="item.emp_images"
                              />
                            </v-flex>

                            <v-flex lg9 md9 sm8 xs6>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content">
                                  <span class="coco-list-label-text content">{{item.code}} :</span>
                                  <span>{{item.name}}</span>
                                  <span style="margin-left:10px;font-weight:bold">{{item.position}}</span>
                                  <!-- <span v-if="item.empType == 0 ">
                                    <strong style="color:green;">&nbsp;รายเดือน</strong> 
                                  </span>
                                  <span v-if="item.empType == 1 ">
                                    <strong style="color:green;">&nbsp;รายวัน</strong>
                                  </span>
                                  <span v-if="item.empType == 2 ">
                                    <strong style="color:green;">&nbsp;รายชั่วโมง</strong>
                                  </span>-->
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                  <span class="coco-list-label-text content">{{item.code}} :</span>
                                  <span style="font-weight:bold">{{item.position}}</span>
                                  <br>
                                  <span>{{item.name}}</span>
                                 
                                  
                                  <!-- <span v-if="item.empType == 0 ">
                                    <strong style="color:green;">&nbsp;รายเดือน</strong> 
                                  </span>
                                  <span v-if="item.empType == 1 ">
                                    <strong style="color:green;">&nbsp;รายวัน</strong>
                                  </span>
                                  <span v-if="item.empType == 2 ">
                                    <strong style="color:green;">&nbsp;รายชั่วโมง</strong>
                                  </span>-->
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{$t('Salary') + ' : '}}
                                        <span>{{thousandSep(item.salary)}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{$t('Totalincome') + ' : '}}
                                        <span>{{thousandSep(item.totalEarning)}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{$t('Deductions') + ' : '}}
                                        <span>{{item.totalDeduct}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span
                                        v-if="item.paymentType == 0"
                                        class="coco-list-label-text hidden-xs-only"
                                      >
                                         {{isEmpty(item.bankName) ?
                                          item.bankName +":" : ''}}
                                        <span>
                                          {{isEmpty(item.bankCode) ?
                                          item.bankCode : ''}}
                                        </span>
                                      </span>
                                      <span
                                        v-if="item.paymentType == 1"
                                        class="coco-list-label-text hidden-xs-only"
                                      >
                                        {{$t('Prompay') + ':'}}
                                        <span>
                                          {{isEmpty(item.promptpayNumber) ?
                                          item.promptpayNumber : ''}}
                                        </span>
                                      </span>
                                      <span
                                        v-if="item.paymentType == 2"
                                        class="coco-list-label-text hidden-xs-only"
                                      >เงินสด</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{$t('Salary') + ' : '}}
                                        <span>{{thousandSep(item.salary)}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{$t('Totalincome') + ' : '}}
                                        <span>{{thousandSep(item.totalEarning)}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{$t('Deductions') + ' : '}}
                                        <span>{{item.totalDeduct}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span
                                        v-if="item.paymentType == 0"
                                        class="coco-list-label-text"
                                      >
                                       {{isEmpty(item.bankName) ?
                                          item.bankName +":" : ''}}
                                        <span>
                                          {{isEmpty(item.bankCode) ?
                                          item.bankCode : ''}}
                                        </span>

                                      </span>
                                      <span
                                        v-if="item.paymentType == 1"
                                        class="coco-list-label-text"
                                      >
                                        {{$t('Prompay') + ':'}}
                                        <span>
                                          {{isEmpty(item.promptpayNumber) ?
                                          item.promptpayNumber : ''}}
                                        </span>
                                      </span>
                                      <span
                                        v-if="item.paymentType == 2"
                                        class="coco-list-label-text"
                                      >เงินสด</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg2 md2 sm2 xs3 text-xs-right>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <span>
                                    <strong>
                                      <h3
                                        style="color:green;padding-right:2px;"
                                      >{{thousandSep(item.totalBalance)}}</h3>
                                    </strong>
                                  </span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </div>
                      <v-card-text class="coco-box-shadow">
                        <!-- เพิ่มใหม่แสดงวันที่เริ่มงาน hidden-sm-only -->
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span class="coco-list-label-text hidden-sm-only">
                              {{$t('StartworkingDate') + ' : '}}
                              <span>{{selectedformatDates(item.startWorkingDate)}}</span>
                            </span>
                            <span class="coco-list-label-text hidden-sm-only">
                              {{$t('WorkingDate') + ' : '}}
                              <span>{{item.workingDate}}</span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span class="coco-list-label-text hidden-sm-only">
                              {{$t('WorkingDate') + ' : '}}
                              <span>{{item.workingDate}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span
                              v-if="item.empType == 0 "
                              class="hidden-sm-only"
                              style="color:#B5B5B5;fontweight:400;padding:4px;"
                            >
                              {{$t('Salary')}}:
                              <span style="color:green">
                                <!-- {{isEmpty(item.salary)? item.salary
                                : 'salary'}}-->
                                {{thousandSep(item.salary)}}
                              </span>
                            </span>
                            <span v-else></span>
                            <span
                              v-if="item.empType == 1 "
                              class="hidden-sm-only"
                              style="color:#B5B5B5;fontweight:400;padding:4px;"
                            >
                              {{$t('Perday')}}:
                              <span style="color:green">
                                {{isEmpty(item.perDay)? item.perDay.toFixed()
                                : 'Perday'}}
                              </span>
                            </span>
                            <span v-else></span>
                            <span
                              v-if="item.empType == 2 "
                              class="hidden-sm-only"
                              style="color:#B5B5B5;fontweight:400;padding:4px;"
                            >
                              {{$t('Perhour')}}:
                              <span style="color:green">
                                {{isEmpty(item.perHour) ?
                                item.perHour.toFixed() : 'Perhour'}}
                              </span>
                            </span>
                            <span v-else></span>
                            <span v-if="item.deductAbsent == 0 || item.deductAbsent == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              ค่าฝีมือ:
                              <span style="color:green">
                                {{isEmpty(item.deductAbsent) ?
                                item.deductAbsent : 'totaldeduct'}}
                              </span>
                            </span>
                            <span v-if="item.totalLeave == 0 || item.totalLeave == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              ค่าตำแหน่ง:
                              <span style="color:green">
                                {{isEmpty(item.totalLeave) ?
                                item.totalLeave : 'totaldeduct'}}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span style="color:#B5B5B5">
                              รวมเงินได้ :
                              <span style="color:green;">{{thousandSep(item.salary)}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.totalOT == 0 || item.totalot == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              ชม.OT:
                              <span style="color:green">
                                {{isEmpty(item.totalOT)? item.totalOT
                                : 'totalOT'}}
                              </span>
                            </span>
                            <span v-if="item.totalOTEvent == 0 || item.totalOTEvent == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              เงินOT:
                              <span style="color:green">
                                {{isEmpty(item.totalOTEvent)? item.totalOTEvent
                                : 'totalOTEvent'}}
                              </span>
                            </span>
                            <span
                              v-for="(items,j) in  table_datalist_resign[i].incomeAndExpenses"
                              :key="j"
                            >
                              <span
                                v-if="items.tranFlag == 0"
                                class="hidden-sm-only"
                                style="color:#B5B5B5;padding:4px;"
                              >
                                {{items.name}} :
                                <span
                                  class="hidden-sm-only"
                                  style="color:green;padding:4px;"
                                >
                                  {{isEmpty(items.amount) ?
                                  items.amount : 'amount'}}
                                </span>
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <span style="color:#B5B5B5;">
                              {{$t('Totalincome') + ':'}}
                              <span
                                style="color:green;"
                              >{{thousandSep(item.totalEarning)}}</span>
                            </span> 
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.totalWorkhour == '0' || item.totalWorkhour == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              ชม ขาดงาน:
                              <span style="color:red;">
                                {{isEmpty(item.totalWorkhour)? item.totalWorkhour
                                : 'totalWorkhour'}}
                              </span>
                            </span>
                            <span v-if="item.totalAbsent == '0' || item.totalAbsent == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              หักเงินขาด:
                              <span style="color:red;">
                                {{isEmpty(item.totalAbsent)? item.totalAbsent
                                : 'totalAbsent'}}
                              </span>
                            </span>
                            <span
                              v-for="(items,j) in  table_datalist_resign[i].incomeAndExpenses"
                              :key="j"
                            >
                              <span
                                v-if="items.tranFlag == 1"
                                class="coco-list-label-text hidden-sm-only"
                              >
                                {{items.name}} :
                                <span style="color:red;">
                                  {{isEmpty(items.amount) ?
                                  items.amount : 'amount'}}
                                </span>
                              </span>
                            </span>

                            <span v-if="item.deductSS == '0' || item.deductSS == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              {{$t('SocialSecurity')}}:
                              <span style="color:red;">
                                {{isEmpty(item.deductSS) ?
                                item.deductSS : ''}}
                              </span>
                            </span>
                            <span v-if="item.deductTax == '0' || item.deductTax == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              {{$t('Tax') + ':'}}
                              <span style="color:red;">
                                {{isEmpty(item.deductTax) ?
                                item.deductTax : 'totaldeduct'}}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <span style="color:#B5B5B5;">
                              {{$t('Totalexpenses') + ':'}}
                              <span
                                style="color:red;"
                              >{{thousandSep(item.totalDeduct)}}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
                <v-flex md12 sm12 xs12 class="hidden-xs-only content">
                  <v-expansion-panel expand>
                    <v-expansion-panel-content
                      style="background-color:#ffffff"
                      v-for="(item,i) in  table_datalist_resign"
                      :key="i"
                    >
                      <div slot="header">
                        <v-card class="coco-box-shadow">
                          <v-layout align-center justify-center row fill-height wrap>
                            <v-flex lg1 md1 sm2 xs3 text-xs-center>
                              <v-avatar
                                v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                                :size="64"
                                color="teal"
                              >
                                <span class="white--text headline">{{item.nickName}}</span>
                              </v-avatar>

                              <Empimage
                                v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                                :json_data="item.emp_images"
                              />
                            </v-flex>

                            <v-flex lg9 md9 sm8 xs6>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content">
                                  <span class="coco-list-label-text content">{{item.code}} :</span>
                                  <span>{{item.name}}</span>
                                  <span style="margin-left:10px;font-weight:bold">{{item.position}}</span>
                                  <!-- <span v-if="item.empType == 0 ">
                                    <strong style="color:green;">&nbsp;รายเดือน</strong>
                                  </span>
                                  <span v-if="item.empType == 1 ">
                                    <strong style="color:green;">&nbsp;รายวัน</strong>
                                  </span>
                                  <span v-if="item.empType == 2 ">
                                    <strong style="color:green;">&nbsp;รายชั่วโมง</strong>
                                  </span>-->
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                
                                  <span class="coco-list-label-text content">{{item.code}} :</span>
                                  <br>
                                  <span>{{item.name}}</span>
                                 
                                  <span style="margin-left:10px;font-weight:bold">{{item.position}} &nbsp;</span>
                                  <!-- <span v-if="item.empType == 0 ">
                                    <strong style="color:green;">&nbsp;รายเดือน</strong>
                                  </span>
                                  <span v-if="item.empType == 1 ">
                                    <strong style="color:green;">&nbsp;รายวัน</strong>
                                  </span>
                                  <span v-if="item.empType == 2 ">
                                    <strong style="color:green;">&nbsp;รายชั่วโมง</strong>
                                  </span>-->
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{$t('Salary') + ' : '}}
                                        <span>{{thousandSep(item.salary)}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{$t('Totalincome') + ' : '}}
                                        <span>{{thousandSep(item.totalEarning)}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{$t('Deductions') + ' : '}}
                                        <span>{{item.totalDeduct}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span
                                        v-if="item.paymentType == 0"
                                        class="coco-list-label-text hidden-xs-only"
                                      >
                                           {{isEmpty(item.bankName) ?
                                          item.bankName +":" : ''}}
                                        <span>
                                          {{isEmpty(item.bankCode) ?
                                          item.bankCode : ''}}
                                        </span>
                                      </span>
                                      <span
                                        v-if="item.paymentType == 1"
                                        class="coco-list-label-text hidden-xs-only"
                                      >
                                        {{$t('Prompay') + ':'}}
                                        <span>
                                          {{isEmpty(item.promptpayNumber) ?
                                          item.promptpayNumber : ''}}
                                        </span>
                                      </span>
                                      <span
                                        v-if="item.paymentType == 2"
                                        class="coco-list-label-text hidden-xs-only"
                                      >เงินสด</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{$t('Salary') + ' : '}}
                                        <span>{{thousandSep(item.salary)}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{$t('Totalincome') + ' : '}}
                                        <span>{{thousandSep(item.totalEarning)}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{$t('Deductions') + ' : '}}
                                        <span>{{item.totalDeduct}}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span
                                        v-if="item.paymentType == 0"
                                        class="coco-list-label-text"
                                      >
                                          {{isEmpty(item.bankName) ?
                                          item.bankName +":" : ''}}
                                        <span>
                                          {{isEmpty(item.bankCode) ?
                                          item.bankCode : ''}}
                                        </span>
                                      </span>
                                      <span
                                        v-if="item.paymentType == 1"
                                        class="coco-list-label-text"
                                      >
                                        {{$t('Prompay') + ':'}}
                                        <span>
                                          {{isEmpty(item.promptpayNumber) ?
                                          item.promptpayNumber : ''}}
                                        </span>
                                      </span>
                                      <span
                                        v-if="item.paymentType == 2"
                                        class="coco-list-label-text"
                                      >เงินสด</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg2 md2 sm2 xs3 text-xs-right>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <span>
                                    <strong>
                                      <h3 style="color:green;">{{thousandSep(item.totalBalance)}}</h3>
                                    </strong>
                                  </span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </div>

                      <v-card-text class="coco-box-shadow">
                        <!-- เพิ่มใหม่ วันที่เริ่มงาน hidden-xs-only content-->
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span class="coco-list-label-text hidden-xs-only content">
                              {{$t('StartworkingDate') + ' : '}}
                              <span>{{selectedformatDates(item.startWorkingDate)}}</span>
                            </span>
                            <span class="coco-list-label-text hidden-xs-only content">
                              {{$t('WorkingDate') + ' : '}}
                              <span>{{item.workingDate}}</span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span class="coco-list-label-text hidden-xs-only content">
                              {{$t('WorkingDate') + ' : '}}
                              <span>{{item.workingDate}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span
                              v-if="item.empType == 0 "
                              class="hidden-xs-only content"
                              style="color:#B5B5B5;fontweight:400;padding:4px;"
                            >
                              {{$t('Salary') + ' : '}}
                              <span
                                style="color:green"
                              >{{thousandSep(item.salary)}}</span>
                            </span>
                            <span v-else></span>
                            <span
                              v-if="item.empType == 1 "
                              class="hidden-xs-only content"
                              style="color:#B5B5B5;fontweight:400;padding:4px;"
                            >
                              {{$t('Perday') + ' : '}}
                              <span style="color:green">
                                {{isEmpty(item.perDay)? item.perDay.toFixed()
                                : 'Perday'}}
                              </span>
                            </span>
                            <span v-else></span>
                            <span
                              v-if="item.empType == 2 "
                              class="hidden-xs-only content"
                              style="color:#B5B5B5;fontweight:400;padding:4px;"
                            >
                              {{$t('Perhour') + ' : '}}
                              <span style="color:green">
                                {{isEmpty(item.perHour) ?
                                item.perHour.toFixed() : 'Perhour'}}
                              </span>
                            </span>
                            <span v-else></span>
                            <span v-if="item.deductAbsent == 0 || item.deductAbsent == null"></span>
                            <span
                              v-else
                              class="hidden-xs-only content"
                              style="color:#B5B5B5;padding:4px;"
                            >
                              ค่าฝีมือ :
                              <span style="color:green">
                                {{isEmpty(item.deductAbsent) ?
                                item.deductAbsent : 'totaldeduct'}}
                              </span>
                            </span>
                            <span v-if="item.totalLeave == 0 || item.totalLeave == null"></span>
                            <span
                              v-else
                              class="hidden-xs-only content"
                              style="color:#B5B5B5;padding:4px;"
                            >
                              ค่าตำแหน่ง :
                              <span style="color:green">
                                {{isEmpty(item.totalLeave) ?
                                item.totalLeave : 'totaldeduct'}}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span style="color:#B5B5B5">
                              รวมเงินได้ :
                              <span style="color:green;">{{thousandSep(item.salary)}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.totalOT == 0 || item.totalot == null"></span>
                            <span
                              v-else
                              class="hidden-xs-only content"
                              style="color:#B5B5B5;padding:4px;"
                            >
                              ชม.OT :
                              <span style="color:green">
                                {{isEmpty(item.totalOT)? item.totalOT
                                : 'salary'}}
                              </span>
                            </span>
                            <span v-if="item.totalOTEvent == 0 || item.totalOTEvent == null"></span>
                            <span
                              v-else
                              class="hidden-xs-only content"
                              style="color:#B5B5B5;padding:4px;"
                            >
                              เงินOT :
                              <span style="color:green">
                                {{isEmpty(item.totalOTEvent)? item.totalOTEvent
                                : 'salary'}}
                              </span>
                            </span>
                            <span
                              v-for="(items,j) in  table_datalist_resign[i].incomeAndExpenses"
                              :key="j"
                            >
                              <span
                                v-if="items.tranFlag == 0"
                                class="hidden-xs-only content"
                                style="color:#B5B5B5;padding:4px;"
                              >
                                {{items.name}} :
                                <span
                                  style="color:green"
                                  class="hidden-xs-only content"
                                >
                                  <!-- {{isEmpty(items.amount) ?
                                  items.amount : 'amount'}}-->
                                  {{items.amount}}
                                </span>
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <span style="color:#B5B5B5;">
                              {{$t('Totalincome') + ':'}}
                              <span
                                style="color:green;"
                              >{{thousandSep(item.totalEarning)}}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.totalWorkhour == '0' || item.totalWorkhour == null"></span>
                            <span
                              v-else
                              class="hidden-xs-only content"
                              style="color:#B5B5B5;padding:4px;"
                            >
                              ชม ขาดงาน:
                              <span style="color:red;">
                                {{isEmpty(item.totalWorkhour)? item.totalWorkhour
                                : 'totalWorkhour'}}
                              </span>
                            </span>
                            <span v-if="item.totalAbsent == '0' || item.totalAbsent == null"></span>
                            <span
                              v-else
                              class="hidden-xs-only content"
                              style="color:#B5B5B5;padding:4px;"
                            >
                              หักเงินขาด:
                              <span style="color:red;">
                                {{isEmpty(item.totalAbsent)? item.totalAbsent
                                : 'totalAbsent'}}
                              </span>
                            </span>
                            <span
                              v-for="(items,j) in  table_datalist_resign[i].incomeAndExpenses"
                              :key="j"
                            >
                              <span
                                v-if="items.tranFlag == 1"
                                class="hidden-xs-only content"
                                style="color:#B5B5B5;padding:4px;"
                              >
                                {{items.name}} :
                                <span style="color:red;">
                                  {{isEmpty(items.amount) ?
                                  items.amount : 'amount'}}
                                </span>
                              </span>
                            </span>

                            <span v-if="item.deductSS == '0' || item.deductSS == null"></span>
                            <span
                              v-else
                              class="hidden-xs-only content"
                              style="color:#B5B5B5;padding:4px;"
                            >
                              {{$t('SocialSecurity')}} :
                              <span style="color:red;">
                                {{isEmpty(item.deductSS) ?
                                item.deductSS : ''}}
                              </span>
                            </span>
                            <span v-if="item.deductTax == '0' || item.deductTax == null"></span>
                            <span
                              v-else
                              class="hidden-xs-only content"
                              style="color:#B5B5B5;padding:4px;"
                            >
                              {{$t('Tax') + ':'}}
                              <span style="color:red;">
                                {{isEmpty(item.deductTax) ?
                                item.deductTax : 'Tax'}}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <span style="color:#B5B5B5;">
                              {{$t('Totalexpenses') + ':'}}
                              <span
                                style="color:red;"
                              >{{thousandSep(item.totalDeduct)}}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
            </v-container>
          </v-layout>
          <v-layout v-if="buttonlist == 1 && (check_permission == true || admin == 'true')">
            <v-flex md12 sm12 xs12 style="max-height:70vh" class="scroll-able" v-if="table_datalist.length > 0">
              <table id="table_detail" class="table table-bordered " style="height:300px !important;overflow: auto;" >
                <thead>
                  <tr
                    style="background-color: #357ca5; color: white;vertical-align: middle"
                    v-html="showheadhtml"
                  ></tr>
                </thead>
                <tbody v-html="showbodyhtml"></tbody>
              </table>
            </v-flex>
            <v-flex md12 sm12 xs12 text-xs-center   v-if="table_datalist.length == 0">
                <h3 style="color:#000;">{{$t('message.Docfail')}}</h3>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
      <!-- FormDialog -->
      <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="snackbarcolor">
        {{ snackmsg }}
        <v-btn dark flat @click="snackbar = false">X</v-btn>
      </v-snackbar>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog v-model="docDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{$t('Employee_payroll_doc')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field  readonly :label="$t('DocumentID')" required v-model="payroll_doc.doc_no"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    :label="$t('Document creation date')" 
                    type="date"
                    v-model="payroll_doc.doc_date"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field  :label="$t('fromdate')"  readonly v-model="payroll_doc.begin_date"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('todate')" readonly v-model="payroll_doc.end_date"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field :label="$t('remark')" v-model="payroll_doc.remark"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="docDialog = false">ยกเลิก</v-btn>
            <v-btn color="blue darken-1" flat @click="saveDoc()">บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

<!-- ปุ่มกด -->
 <v-layout row justify-center>
      <v-dialog v-model="buttondocDialog" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="primary" @click="showCreateDocDialog()">
              <v-icon class="pr-2" size="16">fa-plus</v-icon>
              <span>{{$t('Createpaymentdocuments')}}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="info" @click="checkbutton(1,'downloadexcel')">
              <v-icon class="pr-2" size="16">fa-file-excel</v-icon>
              <span>{{$t('Exportexcel')}}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="primary" @click="checkbutton(1,'doCopyTable')">
              <v-icon class="pr-2" size="16">fa-copy</v-icon>
              <span>{{$t('copy')}}</span>
            </v-btn>
          </v-flex>
          
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="buttondocDialog = false">ยกเลิก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="filterDialog" persistent scrollable max-width="600px">
        <v-card>
          <v-toolbar dark color="primary">
            <v-tooltip bottom>
              <v-btn slot="activator" icon dark @click="filterDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
              <span>{{ $t('close') }}</span>
            </v-tooltip>
            <v-toolbar-title>{{ $t('displayoptions') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat dark @click="process();filterDialog = false">
              <v-icon>save</v-icon>
              <span class="px-2">{{ $t('save') }}</span>
            </v-btn>
          </v-toolbar>
          <v-card-text style="height: 300px;">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-btn block color="info" @click="doToggleHeader('1')">{{ $t('DisplayAll') }}</v-btn>
                </v-flex>
                <v-flex xs6>
                  <v-btn
                    block
                    dark
                    color="deep-orange"
                    @click="doToggleHeader('0')"
                  >{{ $t('NoneDisplayAll') }}</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('type')"
                    v-model="table_head_model.ประเภท"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('Position')"
                    v-model="table_head_model.ตำแหน่ง"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('StartworkingDate')"
                    v-model="table_head_model.วันเริ่มทำงาน"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('WorkingDate')"
                    v-model="table_head_model.วันทำงานเดือนนี้"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('Salary')"
                    v-model="table_head_model.เงินเดือน"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('craftAmount')"
                    v-model="table_head_model.ค่าฝีมือ"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('PositionAmount')"
                    v-model="table_head_model.ค่าตำแหน่ง"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalMoney')"
                    v-model="table_head_model.รวมเงินได้"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('Perday')"
                    v-model="table_head_model.วันละ"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('PerHour')"
                    v-model="table_head_model.ชั่วโมงละ"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <!-- <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalOTHour')"
                    v-model="table_head_model.ชม_OT_รวม"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalOTAmount')"
                    v-model="table_head_model.เงิน_OT_รวม"
                    value="1"
                    hide-details
                  />
                </v-flex> -->
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalOtherIncome')"
                    v-model="table_head_model.รวมรายรับอื่นๆ"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('DetailsOfIncome')"
                    v-model="table_head_model.รายละเอียดรายรับ"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('SpecialHoliday')"
                    v-model="table_head_model.วันหยุดพิเศษ"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('SpecialHolidayIncome')"
                    v-model="table_head_model.รายได้วันหยุดพิเศษ"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalIncome')"
                    v-model="table_head_model.รวมรายได้"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <!-- <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalLeaveHours')"
                    v-model="table_head_model.ชม_ลา_รวม"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalDeductLeave')"
                    v-model="table_head_model.หักเงินลา_รวม"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('LeaveNotDeductingMoney')"
                    v-model="table_head_model.ลาไม่หักเงิน"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalAdsenceHour')"
                    v-model="table_head_model.ชม_ขาด_รวม"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalDeductAdsence')"
                    v-model="table_head_model.หักเงินขาด_รวม"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalLate')"
                    v-model="table_head_model.สาย_รวม"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalDeductLate')"
                    v-model="table_head_model.หักเงินสาย_รวม"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalOutBeforeTime')"
                    v-model="table_head_model.ออกก่อน_รวม"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalDeductOutBeforeTime')"
                    v-model="table_head_model.หักออกก่อน_รวม"
                    value="1"
                    hide-details
                  />
                </v-flex> -->
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('SocialSecurity')"
                    v-model="table_head_model.ประกันสังคม"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('Tax')"
                    v-model="table_head_model.ภาษี"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('DetailsOfExpenses')"
                    v-model="table_head_model.รายละเอียดรายจ่าย"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalOtherExpenses')"
                    v-model="table_head_model.รวมรายจ่ายอื่นๆ"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalDeduct')"
                    v-model="table_head_model.รวมหัก"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TotalBalance')"
                    v-model="table_head_model.คงเหลือเงิน"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('PaymentType')"
                    v-model="table_head_model.ประเภทการจ่ายเงิน"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('AccountNumber')"
                    v-model="table_head_model.เลขที่บัญชี"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <!-- <v-flex md4 sm4 xs6>
                  <v-checkbox
                    :label="$t('TimeAttendance')"
                    v-model="table_head_model.เวลาเข้างาน"
                    value="0"
                    hide-details
                  />
                </v-flex> -->
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import ProcessService from "@/services/ProcessService";
import PayrollService from "@/services/PayrollService";
import Empimage from "../../components/getempimage.vue";
import Utils from "@/utils/";
import XLSX from "xlsx";
import { constants } from "crypto";
import { chown } from "fs";
import FilterComponent from "./Filter";
export default {
  data: () => ({
    years:[],
    year:  2019 ,
    Search_data: "",
     show_search: false,
    payroll_doc: {
      doc_no: "",
      doc_date: new Date().toISOString().substr(0, 10),
      begin_date: "",
      end_date: "",
      remark: "",
      creator_code: localStorage._usercode
    },
     form_filter_data: {
      status: false,
     
    },
    snackbarcolor: "red",
    docDialog: false,
    buttondocDialog:false,
    filterDialog: false,
    table_datalist: [],
    table_datalist_resign: [],
    table_head_model: {
      ชื่อ: "1",
      ประเภท: "1",
      ตำแหน่ง: "1",
      วันเริ่มทำงาน: "1",
      วันทำงานเดือนนี้: "1",
      เงินเดือน: "1",
      ค่าฝีมือ: "1",
      ค่าตำแหน่ง: "1",
      รวมเงินได้: "1",
      วันละ: "1",
      ชั่วโมงละ: "1",
      ชม_OT_รวม: "0",
      เงิน_OT_รวม: "0",
      รายละเอียดรายรับ: "1",
      รวมรายรับอื่นๆ: "1",
      วันหยุดพิเศษ: "1",
      รายได้วันหยุดพิเศษ: "1",
      รวมรายได้: "1",
      ชม_ลา_รวม: "0",
      หักเงินลา_รวม: "0",
      ลาไม่หักเงิน: "0",
      ชม_ขาด_รวม: "0",
      หักเงินขาด_รวม: "0",
      สาย_รวม: "0",
      หักเงินสาย_รวม: "0",
      ออกก่อน_รวม: "0",
      หักออกก่อน_รวม: "0",
      ประกันสังคม: "1",
      ภาษี: "1",
      รายละเอียดรายจ่าย: "1",
      รวมรายจ่ายอื่นๆ: "1",
      รวมหัก: "1",
      คงเหลือเงิน: "1",
      ประเภทการจ่ายเงิน: "1",
      เลขที่บัญชี: "1",
      เวลาเข้างาน: "0"
    },
    json_fields: {
      ชื่อ: "name",
      ประเภท: "empType",
      ตำแหน่ง: "position",
      วันเริ่มทำงาน: "startWorkingDate",
      วันทำงานเดือนนี้: "1",
      เงินเดือน: "salary",
      ค่าฝีมือ: "craftAmount",
      ค่าตำแหน่ง: "positionAmount",
      รวมเงินได้: "incomeBeforeExtraAndOT",
      วันละ: "perDay",
      ชั่วโมงละ: "perHour",
      ชม_OT_รวม: "OT",
      เงิน_OT_รวม: "OTAmount",
      รวมรายรับอื่นๆ: "totalAddIncome",
      วันหยุดพิเศษ: "extraHoliday",
      รายได้วันหยุดพิเศษ: "extraHolidayAmount",
      รวมรายได้: "incomeBeforeExpenses",
      ชม_ลา_รวม: "leaveAmount",
      หักเงินลา_รวม: "leaveAmountEvent",
      ลาไม่หักเงิน: "leaveUncut",
      ชม_ขาด_รวม: "absentAmount",
      หักเงินขาด_รวม: "absentAmountEvent",
      สาย_รวม: "totalLate",
      หักเงินสาย_รวม: "lateAmount",
      ออกก่อน_รวม: "totalOB",
      หักออกก่อน_รวม: "outBeforTimeAmount",
      ประกันสังคม: "insuranceAmount",
      ภาษี: "vatAmount",
      รายละเอียดรายจ่าย: "notCheckInAmount",
      รวมรายจ่ายอื่นๆ: "totalAddExpenses",
      รวมหัก: "deductAmount",
      คงเหลือเงิน: "balanceAmount",
      ประเภทการจ่ายเงิน: "paymentType",
      เลขที่บัญชี: "bankcode"
    },
    startmonth: [
      { txt: "เลือกเดือนเริ่มต้น", val: 0 },
      { txt: "มกราคม", val: 1 },
      { txt: "กุมภาพันธ์", val: 2 },
      { txt: "มีนาคม", val: 3 },
      { txt: "เมษายน", val: 4 },
      { txt: "พฤษภาคม", val: 5 },
      { txt: "มิถุนายน", val: 6 },
      { txt: "กรกฏาคม", val: 7 },
      { txt: "สิงหาคม", val: 8 },
      { txt: "กันยายน", val: 9 },
      { txt: "ตุลาคม", val: 10 },
      { txt: "พฤศจิกายน", val: 11 },
      { txt: "ธันวาคม", val: 12 },
    ],
    endmonth: [
      { txt: "เลือกเดือนสิ้นสุด", val: 0 },
      { txt: "มกราคม", val: 1 },
      { txt: "กุมภาพันธ์", val: 2 },
      { txt: "มีนาคม", val: 3 },
      { txt: "เมษายน", val: 4 },
      { txt: "พฤษภาคม", val: 5 },
      { txt: "มิถุนายน", val: 6 },
      { txt: "กรกฏาคม", val: 7 },
      { txt: "สิงหาคม", val: 8 },
      { txt: "กันยายน", val: 9 },
      { txt: "ตุลาคม", val: 10 },
      { txt: "พฤศจิกายน", val: 11 },
      { txt: "ธันวาคม", val: 12 },
    ],
    Start_month: "",
    End_month: "",
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8"
        }
      ]
    ],
    buttonlist: 0,
    table_head_count: 1,
    pageActive: 1,
    delDialogStatus: false,
    from_date: "",
    to_date: "",
    delDialog: {
      roworder: "",
      name: "",
      emp_code: "",
      date: ""
    },
    snackbar: false,
    snackmsg: "",
    snack_type: "",
    responvalue: "",
    showbodyhtml: "",
    showheadhtml: "",
    bodyHtml: "",
    footerHtml: "",
    workhour_rate: [],
    ot_rate: [],
    absent_rate: [],
    leave_rate: [],
    ob_rate: [],
    ot_value: [],
    otobj: [],
    headReceive: [],
    headExpenses: [],
    earningDetailName: "",
    responvalue: [],
    late_rate: [],
    income: "",
    expenses: "",
    check_permission:false,
    admin:false
  }),
  created: function() {
    this.createyear();
    this.checkpermission("SalaryTableList");
    console.log(this.check_permission)
    this.admin = localStorage._is_admin;
    this.commitSetToolbar({
      patternTool: "0"
    });
    this.$store.watch(
      state => {
        state.filter.SelectBranch;
        state.filter.SelectDepartment;
        state.filter.SelectPosition;
        state.filter.SearchData;
      },
      () => {},
      {
        deep: true
      }
    );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    Empimage,
    FilterComponent
  },
  computed: {
    ...mapState("filter", [
      "Branch_List",
      "Department_List",
      "Position_List",
      "Errormsg",
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData"
    ]),
    ...mapState("app", ["showLoading"]),
    ...mapState("permissionmenu", ["permission_List"]),
  //   branchSelect: {
  //     get() {
  //       return this.SelectBranch;
  //     },
  //     async set(value) {
  //       await this.getDepartment({ branch: value });
  //     }
  //   },
  //   departmentSelect: {
  //     get() {
  //       return this.SelectDepartment;
  //     },
  //     async set(value) {
  //       await this.getPosition({ department: value });
  //     }
  //   },
  //   positionSelect: {
  //     get() {
  //       return this.SelectPosition;
  //     },
  //     async set(value) {
  //       await this.selectedPosition({ data: value });
  //     }
  //   }
   },
  methods: {
    ...mapMutations("filter", [
      "setShowFilter",
      "selectedFormDate",
      "selectedto_date",
      "getAllEmployeeByBranch",
      "selectedPosition"
    ]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
      checkpermission(page){
        let checkEdit = false
        if(this.permission_List.length != 0){
             this.permission_List.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                 }
             });
        }
        else{
            checkEdit = false;
        }
        this.check_permission = checkEdit
    },
     showFilter(status){
      this.form_filter_data = {
        status: status,
        data:1
      };
    },
    createyear() {
      var curryears = new Date().toISOString().substr(0, 4);
      var startyear = parseInt(curryears) - 10;
      var endyear = parseInt(curryears)
      console.log("curryears", curryears);
      console.log("startyear", startyear);
      console.log("endyear", endyear);
      for (var d = startyear; d <= endyear; d++) {
        this.years.push({ name: d });
      }
      console.log(this.years);
    },
    onCloseFormDialog() {
      this.form_filter_data.status = false;
      this.onload = true;
      // this.process();
    },
    saveDoc() {
      let searchVal = "";
      let department = "";
      this.commitSetShowLoading(true);
      if (this.SearchData == undefined) {
        searchVal = "";
      } else {
        searchVal = this.SearchData;
      }
      if (this.SelectDepartment == "All" || this.SelectDepartment == "") {
        department = "";
      } else {
        department = this.SelectDepartment;
      }
      // console.log(this.payroll_doc);
      // console.log(department);
      PayrollService.createPayrollDoc(
        searchVal,
        this.payroll_doc.doc_no,
        this.payroll_doc.doc_date,
        this.payroll_doc.begin_date,
        this.payroll_doc.end_date,
        this.SelectBranch,
        department,
        this.payroll_doc.remark
      )
        .then(res => {
          this.commitSetShowLoading(false);
          this.snackbarcolor = "success";
          this.snackmsg = "สร้างเอกสารจ่ายเงินสำเร็จ";
          this.snackbar = true;
          this.docDialog = false;
        })
        .catch(err => {
          this.commitSetShowLoading(false);
          this.snackbarcolor = "error";
          this.snackmsg = "เอกสารเดือนนี้ถูกสร้างแล้ว";
          this.snackbar = true;
          this.docDialog = false;
        });
    },
    downloadexcel() {
      //this.checkbutton(1);
      var config = { raw: true, type: "string" };
      var payroll = XLSX.utils.table_to_sheet(
        document.getElementById("table_detail"),
        config
      );
      //console.log(config);
      //console.log(payroll);
      var wb = XLSX.utils.book_new();
      //console.log(wb);
      XLSX.utils.book_append_sheet(wb, payroll, "payroll");
      XLSX.writeFile(wb, "salarytable.xlsx");
    },
    _today() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();

      var output =
        d.getFullYear() +
        "-" +
        (month < 10 ? "0" : "") +
        month +
        "-" +
        (day < 10 ? "0" : "") +
        day;

      return output;
    },
    showCreateDocDialog() {
      if (
        this.from_date == "" ||
        this.from_date == undefined ||
        (this.to_date == "" || this.from_date == undefined) ||
        this.SelectBranch == ""
      ) {
        this.snackbar = true;
        this.snackmsg = "กรุณาประมวลผลเงินเดือนก่อนสร้างเอกสารจ่ายเงิน";
      } else {
        this.payroll_doc.doc_no = this._docno("PR") + this._docdate();
        this.payroll_doc.begin_date = this.from_date;
        this.payroll_doc.end_date = this.to_date;
        this.docDialog = true;
      }
    },
    _docno(head) {
      return (
        head +
        "-xxx".replace(/[xy]/g, function(c) {
          var r = (Math.random() * 8) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        })
      );
    },
    _docdate() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours();
      var min = d.getMinutes();

      var output =
        d.getFullYear() +
        "" +
        (month < 10 ? "0" : "") +
        month +
        "" +
        (day < 10 ? "0" : "") +
        day +
        hour +
        min;

      return output;
    },
    selectChoice() {
      //console.log(this.ChoiceSelected);
      if (this.ChoiceSelected == 0) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.from_date = this.selectedformatDate(firstDay);
        this.to_date = this.selectedformatDate(lastDay);

        // this.process();
      } else if (this.ChoiceSelected == 1) {
        var curr = new Date();
        var first = curr.getDate() - curr.getDay();
        var last = first + 6;
        var firstday = new Date(curr.setDate(first)).toUTCString();
        var lastday = new Date(curr.setDate(last)).toUTCString();
        this.from_date = this.selectedformatDate(firstday);
        this.to_date = this.selectedformatDate(lastday);
        // this.process();
      } else if (this.ChoiceSelected == 2) {
        var curr = new Date();
        this.from_date = this.selectedformatDate(curr);
        this.to_date = this.selectedformatDate(curr);
        // this.process();
      } else if (this.ChoiceSelected == 3) {
        var curr = new Date();
        var first = curr.getDate() - curr.getDay();
        var last = first - 6;
        var firstday = new Date(curr.setDate(first)).toUTCString();
        var lastday = new Date(curr.setDate(last)).toUTCString();
        if (curr.setDate(first) > curr.setDate(last)) {
          this.from_date = this.selectedformatDate(lastday);
          this.to_date = this.selectedformatDate(firstday);
        } else if (curr.setDate(first) < curr.setDate(last)) {
          this.from_date = this.selectedformatDate(firstday);
          this.to_date = this.selectedformatDate(lastday);
        }
        // this.process();
      } else if (this.ChoiceSelected == 4) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
        this.from_date = this.selectedformatDate(firstDay);
        this.to_date = this.selectedformatDate(lastDay);
        // this.process();
      } else {
        this.from_date = "";
        this.to_date = "";
      }
    },
    selectedformatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    process() {
      this.headExpenses =[];
      this.headReceive =[];
      this.ot_rate = [];
      this.absent_rate =[];
      this.leave_rate =[];
      this.ob_rate =[];
      this.late_rate =[];
      if (this.from_date == "" || this.to_date == ""  ) {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกสาขาและวันที่";
       
      } else {
        this.commitSetShowLoading(true);
        let searchVal = "";
        if (this.Search_data == undefined) {
          searchVal = "";
        } else {
          searchVal = this.Search_data;
        }
        console.log("search : " + this.SearchData);
        console.log("from_date : " + this.from_date);
        console.log("to_date : " + this.to_date);
        ProcessService.getSalaryTable(
          this.SelectBranch,
          this.SelectDepartment,
          this.SelectPosition,
          searchVal,
          this.from_date,
          this.to_date
        )
          

          .then(res => {
            console.log(res.data);
            this.table_datalist = [];
            this.table_datalist_resign = [];
            this.commitSetShowLoading(false);
            this.setShowDetail(res.data);

            this.table_datalist = res.data; 
            this.table_datalist.forEach(element => {
              if (element.isResign == false) {
                 let value =  element.name.split("(");
                  let name =  value[0];
                  let nickname ="";
                  if(value[1]!= '' && value[1]!= undefined){
                  let arrnickname = value[1].split(")");
                    nickname = arrnickname[0];
                    
                  }else{
                    nickname = "";
                  }
                this.table_datalist_resign.push(element);
                console.log(this.table_datalist_resign);
              } else if (element.isResign == true) {
               
              }
            });

            console.log(this.table_datalist);
          })

          .catch(err => {
            console.log(err);
          });
      }
    },
    searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        v.process("Filter");
      }, 1500);
    },
    searchClick() {
      if (this.show_search) {
        this.show_search = false;
        $('#pagetitleshow').removeClass('showtitlepage')
      } else {
        this.show_search = true;
        $('#pagetitleshow').addClass('showtitlepage')
        console.log($('#pagetitleshow'))
      }
    },
     onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      //console.log("win_scroll_top " + win_scroll_top);
      let width = $(".contain_width").width();
      //console.log("width " + width);
      if (win_scroll_top > 100) {
        $(".search_in_page").show();
        $(".search_in_page").css("width", width);
      } else {
        $(".search_in_page").hide();
      }
      /* if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          //this.getEmployeeList('List');
          console.log('last');
        }
        if(this.processing && this.canLoadMore){
          console.log('not last');
        }
       }*/
    },
    setShowDetail(response) {
      let ng = this;
      this.bodyHtml = "";
      this.footerHtml = "";
      this.responvalue = response;
      for (var i = 0; i < response.length; i++) {
        for (var v = 0; v < response[i].processTimes.length; v++) {
          let valueOt = response[i].processTimes[v].ot_rate;
          if (typeof this.ot_rate.find(e => e == valueOt) == "undefined") {
            let evObj = valueOt;
            if (evObj > 0.0) {
              this.ot_rate.push(parseFloat(evObj));
            }
          }
          let valueAbsent = response[i].processTimes[v].deduct_absent_rate;
          if (
            typeof this.absent_rate.find(e => e == valueAbsent) == "undefined"
          ) {
            let evObj = valueAbsent;
            //console.log(evObj)
            if (evObj > 0.0) {
              this.absent_rate.push(parseFloat(evObj));
            }
          }
          let valueLeave = response[i].processTimes[v].deduct_leave_rate;
          if (
            typeof this.leave_rate.find(e => e == valueLeave) == "undefined"
          ) {
            let evObj = valueLeave;

            this.leave_rate.push(parseFloat(evObj));
          }
          let valueOB = response[i].processTimes[v].deduct_ob_rate;
          if (typeof this.ob_rate.find(e => e == valueOB) == "undefined") {
            let evObj = valueOB;
            if (evObj > 0.0) {
              this.ob_rate.push(parseFloat(evObj));
            }
          }
          let valueLate = response[i].processTimes[v].deduct_late_rate;
          if (typeof this.late_rate.find(e => e == valueLate) == "undefined") {
            let evObj = valueLate;
            if (evObj > 0.0) {
              this.late_rate.push(parseFloat(evObj));
            }
          }
        }
        for (var x = 0; x < response[i].incomeAndExpenses.length; x++) {
          let name = response[i].incomeAndExpenses[x].name;
          let flag = response[i].incomeAndExpenses[x].tranFlag;
          if (flag == 0) {
            if (typeof this.headReceive.find(e => e == name) == "undefined") {
              let evObj = name;
              this.headReceive.push(evObj);
            }
          } else {
            if (typeof this.headExpenses.find(e => e == name) == "undefined") {
              let evObj = name;
              this.headExpenses.push(evObj);
            }
          }
        }
      }

      this.ot_rate = this.ot_rate.sort(function(a, b) {
        return a - b;
      });
      this.absent_rate = this.absent_rate.sort(function(a, b) {
        return a - b;
      });
      this.leave_rate = this.leave_rate.sort(function(a, b) {
        return a - b;
      });
      this.late_rate = this.late_rate.sort(function(a, b) {
        return a - b;
      });
      this.ob_rate = this.ob_rate.sort(function(a, b) {
        return a - b;
      });

      this.renderheader();

      response
        .sort(function(a, b) {
          a.code.localeCompare(b.code);
        })
        .sort(function(a, b) {
          a.department_name.localeCompare(b.department_name);
        });
      let retData = ng.groupBy(response, "department_name");
      let lastRowSummary = {
        salary: 0.0,
        craftAmount: 0.0,
        positionAmount: 0.0,
        incomeBeforeExtraAndOT: 0.0,
        perDay: 0.0,
        perHour: 0.0,
        extraAmount: 0.0,
        extraHoliday: 0.0,
        extraHolidayAmount: 0.0,
        OT: 0.0,
        OTAmount: 0.0,
        totalAddIncome: 0.0,
        incomeBeforeExpenses: 0.0,
        leave: 0.0,
        leaveUncut: 0.0,
        leaveAmount: 0.0,
        leaveEvent: 0.0,
        leaveAmountEvent: 0.0,
        absent: 0.0,
        absentAmount: 0.0,
        absentEvent: 0.0,
        absentAmountEvent: 0.0,
        totalLate: 0.0,
        lateAmount: 0.0,
        totalOB: 0.0,
        outBeforTimeAmount: 0.0,
        insuranceAmount: 0.0,
        vatAmount: 0.0,
        notCheckInAmount: 0.0,
        employeeShirtAmount: 0.0,
        advanceAmount: 0.0,
        totalAddExpenses: 0.0,
        advancePayment: 0.0,
        deductAmount: 0.0,
        balanceAmount: 0.0
      };
      var lastSummaryOT = [];
      var lastSummaryOTInc = [];
      var lastSummaryLeave = [];
      var lastSummaryLeaveInc = [];
      var lastSummaryAbsent = [];
      var lastSummaryAbsentInc = [];
      var lastSummaryOb = [];
      var lastSummaryObInc = [];
      var lastSummaryLate = [];
      var lastSummaryLateInc = [];
      var lastSummaryTaxlevel = [];
      var lastSummaryReceive = [];
      var lastSummaryExpenses = [];
      console.log("retData: ", retData);
      for (let item in retData) {
        let departmentHtml = "";
        let rowHtml = "";
        let footerDepartmentHtml = "";
        let departName =
          item.toString() == "" ? "No Department" : item.toString();
        departmentHtml += this.renderDepartment(
          departName,
          ng.ot_rate,
          ng.absent_rate,
          ng.leave_rate,
          ng.ob_rate,
          ng.late_rate,
          response,
          ng.headReceive,
          ng.headExpenses
        );
        var groupSummaryReceive = [];
        var groupSummaryExpenses = [];
        var groupSummaryOT = [];
        var groupSummaryOTInc = [];
        var groupSummaryLeave = [];
        var groupSummaryLeaveInc = [];
        var groupSummaryAbsent = [];
        var groupSummaryAbsentInc = [];
        var groupSummaryOb = [];
        var groupSummaryObInc = [];
        var groupSummaryLate = [];
        var groupSummaryLateInc = [];
        var groupSummaryTaxlevel = [];
        let groupSummary = {
          salary: 0.0,
          craftAmount: 0.0,
          positionAmount: 0.0,
          incomeBeforeExtraAndOT: 0.0,
          perDay: 0.0,
          perHour: 0.0,
          extraAmount: 0.0,
          extraHoliday: 0.0,
          extraHolidayAmount: 0.0,
          OT: 0.0,
          OTAmount: 0.0,
          totalAddIncome: 0.0,
          incomeBeforeExpenses: 0.0,
          leave: 0.0,
          leaveUncut: 0.0,
          leaveAmount: 0.0,
          leaveEvent: 0.0,
          leaveAmountEvent: 0.0,
          absent: 0.0,
          absentAmount: 0.0,
          absentEvent: 0.0,
          absentAmountEvent: 0.0,
          totalLate: 0.0,
          lateAmount: 0.0,
          totalOB: 0.0,
          outBeforTimeAmount: 0.0,
          insuranceAmount: 0.0,
          vatAmount: 0.0,
          notCheckInAmount: 0.0,
          employeeShirtAmount: 0.0,
          advanceAmount: 0.0,
          totalAddExpenses: 0.0,
          advancePayment: 0.0,
          deductAmount: 0.0,
          balanceAmount: 0.0
        };

        retData[item].forEach(function(employee, i) {
          if (
            (employee.isResign == false && employee.totalWorkDay == 0 && employee.isSpecial == true) ||(employee.isResign == true && employee.totalWorkDay > 0) ||
            (employee.isResign == false && employee.totalWorkDay > 0)
          ) {
           
            let craftAmount = 0;
            let positionAmount = 0;
            let extraAmount = 0;
            let insuranceAmount = 0;
            let vatAmount = 0;
            let advancePayment = 0;
            craftAmount += employee.incomeCraft;
            positionAmount += employee.incomePosition;
            extraAmount += employee.incomeSpecial;
            insuranceAmount += employee.deductSS;

            vatAmount = employee.deductTax;
            rowHtml += ng.renderNormalRow(
              employee,
              craftAmount,
              positionAmount,
              extraAmount,
              insuranceAmount,
              vatAmount,
              advancePayment,
              ng.ot_rate,
              ng.absent_rate,
              ng.leave_rate,
              ng.ob_rate,
              ng.late_rate,
              ng.headReceive,
              ng.headExpenses
            );

            groupSummary.salary += employee.salary;
            groupSummary.craftAmount += craftAmount;
            groupSummary.positionAmount += positionAmount;

            if (employee.empType == 1) {
              if (employee.perDay > 0) {
                groupSummary.incomeBeforeExtraAndOT +=
                  employee.perDay * employee.totalWorkDay +
                  craftAmount +
                  positionAmount;
              } else {
                groupSummary.incomeBeforeExtraAndOT +=
                  employee.totalByDayEarning;
              }
            } else if (employee.empType == 2) {
              if (employee.perHour > 0) {
                groupSummary.incomeBeforeExtraAndOT +=
                  employee.perHour * employee.totalWorkhour +
                  craftAmount +
                  positionAmount;
              } else {
                groupSummary.incomeBeforeExtraAndOT +=
                  employee.totalEarningTypeHours;
              }
            } else {
              if (employee.isResign || employee.isNewbie) {
                groupSummary.incomeBeforeExtraAndOT +=
                  employee.perDay * employee.totalWorkDay;
              } else {
                groupSummary.incomeBeforeExtraAndOT +=
                  employee.salary + craftAmount + positionAmount;
              }
            }

            groupSummary.perDay += employee.perDay;
            groupSummary.perHour += employee.perHour;
            groupSummary.extraAmount += extraAmount;
            groupSummary.extraHoliday += employee.holidaywork;
            groupSummary.extraHolidayAmount += employee.holidayworkearning;
            groupSummary.OT += employee.totalOT;

            for (var y = 0; y < ng.headReceive.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter(
                c => c.name == ng.headReceive[y] && c.tranFlag == 0
              );
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }
              if (groupSummaryReceive.length == ng.headReceive.length) {
                groupSummaryReceive[y] = groupSummaryReceive[y] + value;
              } else {
                groupSummaryReceive.push(value);
              }
            }
            for (var y = 0; y < ng.headExpenses.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter(
                c => c.name == ng.headExpenses[y] && c.tranFlag == 1
              );
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }
              if (groupSummaryExpenses.length == ng.headExpenses.length) {
                groupSummaryExpenses[y] = groupSummaryExpenses[y] + value;
              } else {
                groupSummaryExpenses.push(value);
              }
            }
            for (var y = 0; y < ng.ot_rate.length; y++) {
              var value = 0;
              var ottime = 0;
              let rowz = employee.processTimes.filter(
                c => c.ot_rate == ng.ot_rate[y]
              );
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].ot_by_date);
                ottime += parseFloat(rowz[v].total_ottime);
              }

              if (groupSummaryOT.length == ng.ot_rate.length) {
                groupSummaryOT[y] = groupSummaryOT[y] + ottime;
                groupSummaryOTInc[y] = groupSummaryOTInc[y] + value;
              } else {
                groupSummaryOT.push(ottime);
                groupSummaryOTInc.push(value);
              }
            }
            for (var y = 0; y < ng.leave_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter(
                c => c.deduct_leave_rate == ng.leave_rate[y]
              );
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.leave_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].deduct_leave_by_date);
                time += parseFloat(rowz[v].total_leavetime);
              }

              if (groupSummaryLeave.length == ng.leave_rate.length) {
                groupSummaryLeave[y] = groupSummaryLeave[y] + time;
                groupSummaryLeaveInc[y] = groupSummaryLeaveInc[y] + value;
              } else {
                groupSummaryLeave.push(time);
                groupSummaryLeaveInc.push(value);
              }
            }
            for (var y = 0; y < ng.absent_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter(
                c => c.deduct_absent_rate == ng.absent_rate[y]
              );
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_absent_by_date);
                time += parseFloat(rowz[v].total_absenttime);
              }

              if (groupSummaryAbsent.length == ng.absent_rate.length) {
                groupSummaryAbsent[y] = groupSummaryAbsent[y] + time;
                groupSummaryAbsentInc[y] = groupSummaryAbsentInc[y] + value;
              } else {
                groupSummaryAbsent.push(time);
                groupSummaryAbsentInc.push(value);
              }
            }
            for (var y = 0; y < ng.late_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter(
                c => c.deduct_late_rate == ng.late_rate[y]
              );
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_late_by_date);
                time += parseFloat(rowz[v].total_latetime);
              }

              if (groupSummaryLate.length == ng.late_rate.length) {
                groupSummaryLate[y] = groupSummaryLate[y] + time;
                groupSummaryLateInc[y] = groupSummaryLateInc[y] + value;
              } else {
                groupSummaryLate.push(time);
                groupSummaryLateInc.push(value);
              }
            }
            for (var y = 0; y < ng.ob_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter(
                c => c.deduct_ob_rate == ng.ob_rate[y]
              );
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_ob_by_date);
                time += parseFloat(rowz[v].total_out_before_time);
              }

              if (groupSummaryOb.length == ng.ob_rate.length) {
                groupSummaryOb[y] = groupSummaryOb[y] + time;
                groupSummaryObInc[y] = groupSummaryObInc[y] + value;
              } else {
                groupSummaryOb.push(time);
                groupSummaryObInc.push(value);
              }
            }

            /* for (var k = 0; k < employee.taxLevels.length; k++) {
                             if (groupSummaryTaxlevel.length == employee.taxLevels.length) {
                                 groupSummaryTaxlevel[k] = groupSummaryTaxlevel[k] + parseFloat(employee.taxLevels[k].net);
                             } else {
                                 groupSummaryTaxlevel.push(parseFloat(employee.taxLevels[k].net))
                             }


                         }*/
            //console.log(groupSummaryTaxlevel)
            //console.log(groupSummaryOTInc)
            groupSummary.OTAmount += employee.otEarning;

            groupSummary.totalAddIncome += employee.totalAddIncome;
            groupSummary.incomeBeforeExpenses += employee.totalEarning;
            groupSummary.leave += employee.totalLeave;
            groupSummary.leaveUncut += employee.totalLeaveUncut;
            groupSummary.leaveAmount += employee.deductLeave;
            groupSummary.leaveEvent += employee.totalLeaveEvent;
            groupSummary.leaveAmountEvent += employee.deductLeaveEvent;
            groupSummary.absent += employee.totalAbsent;
            groupSummary.absentAmount += employee.deductAbsent;
            groupSummary.absentEvent += employee.totalAbsentEvent;
            groupSummary.absentAmountEvent += employee.deductAbsentEvent;

            groupSummary.lateAmount += employee.deductLate;
            groupSummary.totalLate += employee.totalLate;
            groupSummary.totalOB += employee.totalOutbefore;
            groupSummary.outBeforTimeAmount += employee.deductOutbefore;
            groupSummary.insuranceAmount += insuranceAmount;
            groupSummary.vatAmount += vatAmount;
            groupSummary.notCheckInAmount = 0.0;
            groupSummary.employeeShirtAmount = 0.0;
            groupSummary.advanceAmount = 0.0;
            groupSummary.totalAddExpenses += employee.totalAddExpenses;
            groupSummary.advancePayment += advancePayment;
            groupSummary.deductAmount += employee.totalDeduct;
            groupSummary.balanceAmount += employee.totalBalance;

            lastRowSummary.salary += employee.salary;
            lastRowSummary.craftAmount += craftAmount;
            lastRowSummary.positionAmount += positionAmount;

            if (employee.empType == 1) {
              if (employee.perDay > 0) {
                lastRowSummary.incomeBeforeExtraAndOT +=
                  employee.perDay * employee.totalWorkDay +
                  craftAmount +
                  positionAmount;
              } else {
                lastRowSummary.incomeBeforeExtraAndOT +=
                  employee.totalByDayEarning;
              }
            } else if (employee.empType == 2) {
              if (employee.perHour > 0) {
                lastRowSummary.incomeBeforeExtraAndOT +=
                  employee.perHour * employee.totalWorkhour +
                  craftAmount +
                  positionAmount;
              } else {
                lastRowSummary.incomeBeforeExtraAndOT +=
                  employee.totalEarningTypeHours;
              }
            } else {
              if (employee.isResign || employee.isNewbie) {
                lastRowSummary.incomeBeforeExtraAndOT +=
                  employee.perDay * employee.totalWorkDay;
              } else {
                lastRowSummary.incomeBeforeExtraAndOT +=
                  employee.salary + craftAmount + positionAmount;
              }
            }

            lastRowSummary.perDay += employee.perDay;
            lastRowSummary.perHour += employee.perHour;
            lastRowSummary.extraAmount += extraAmount;
            lastRowSummary.extraHoliday += employee.holidaywork;
            lastRowSummary.extraHolidayAmount += employee.holidayworkearning;

            for (var y = 0; y < ng.headReceive.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter(
                c => c.name == ng.headReceive[y] && c.tranFlag == 0
              );
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }

              if (lastSummaryReceive.length == ng.headReceive.length) {
                lastSummaryReceive[y] = lastSummaryReceive[y] + value;
              } else {
                lastSummaryReceive.push(value);
              }
            }
            for (var y = 0; y < ng.headExpenses.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter(
                c => c.name == ng.headExpenses[y] && c.tranFlag == 1
              );
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }

              if (lastSummaryExpenses.length == ng.headExpenses.length) {
                lastSummaryExpenses[y] = lastSummaryExpenses[y] + value;
              } else {
                lastSummaryExpenses.push(value);
              }
            }
            for (var y = 0; y < ng.ot_rate.length; y++) {
              var value = 0;
              var ottime = 0;
              let rowz = employee.processTimes.filter(
                c => c.ot_rate == ng.ot_rate[y]
              );
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].ot_by_date);
                ottime += parseFloat(rowz[v].total_ottime);
              }

              if (lastSummaryOT.length == ng.ot_rate.length) {
                lastSummaryOT[y] = lastSummaryOT[y] + ottime;
                lastSummaryOTInc[y] = lastSummaryOTInc[y] + value;
              } else {
                lastSummaryOT.push(ottime);
                lastSummaryOTInc.push(value);
              }
            }
            for (var y = 0; y < ng.leave_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter(
                c => c.deduct_leave_rate == ng.leave_rate[y]
              );
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.leave_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].deduct_leave_by_date);
                time += parseFloat(rowz[v].total_leavetime);
              }

              if (lastSummaryLeave.length == ng.leave_rate.length) {
                lastSummaryLeave[y] = lastSummaryLeave[y] + time;
                lastSummaryLeaveInc[y] = lastSummaryLeaveInc[y] + value;
              } else {
                lastSummaryLeave.push(time);
                lastSummaryLeaveInc.push(value);
              }
            }
            for (var y = 0; y < ng.absent_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter(
                c => c.deduct_absent_rate == ng.absent_rate[y]
              );
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_absent_by_date);
                time += parseFloat(rowz[v].total_absenttime);
              }

              if (lastSummaryAbsent.length == ng.absent_rate.length) {
                lastSummaryAbsent[y] = lastSummaryAbsent[y] + time;
                lastSummaryAbsentInc[y] = lastSummaryAbsentInc[y] + value;
              } else {
                lastSummaryAbsent.push(time);
                lastSummaryAbsentInc.push(value);
              }
            }
            for (var y = 0; y < ng.late_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter(
                c => c.deduct_late_rate == ng.late_rate[y]
              );
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_late_by_date);
                time += parseFloat(rowz[v].total_latetime);
              }

              if (lastSummaryLate.length == ng.late_rate.length) {
                lastSummaryLate[y] = lastSummaryLate[y] + time;
                lastSummaryLateInc[y] = lastSummaryLateInc[y] + value;
              } else {
                lastSummaryLate.push(time);
                lastSummaryLateInc.push(value);
              }
            }
            for (var y = 0; y < ng.ob_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter(
                c => c.deduct_ob_rate == ng.ob_rate[y]
              );
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_ob_by_date);
                time += parseFloat(rowz[v].total_out_before_time);
              }

              if (lastSummaryOb.length == ng.ob_rate.length) {
                lastSummaryOb[y] = lastSummaryOb[y] + time;
                lastSummaryObInc[y] = lastSummaryObInc[y] + value;
              } else {
                lastSummaryOb.push(time);
                lastSummaryObInc.push(value);
              }
            }
            /* for (var k = 0; k < employee.taxLevels.length; k++) {
                             if (lastSummaryTaxlevel.length == employee.taxLevels.length) {
                                 lastSummaryTaxlevel[k] = lastSummaryTaxlevel[k] + parseFloat(employee.taxLevels[k].net);
                             } else {
                                 lastSummaryTaxlevel.push(parseFloat(employee.taxLevels[k].net));
                             }


                         }*/
            //console.log(lastSummaryOT)
            //console.log(lastSummaryOTInc)
            lastRowSummary.OT += employee.totalOT;
            lastRowSummary.OTAmount += employee.otEarning;
            lastRowSummary.totalAddIncome += employee.totalAddIncome;
            lastRowSummary.incomeBeforeExpenses += employee.totalEarning;
            lastRowSummary.leave += employee.totalLeave;
            lastRowSummary.leaveUncut += employee.totalLeaveUncut;
            lastRowSummary.leaveAmount += employee.deductLeave;
            lastRowSummary.leaveEvent += employee.totalLeaveEvent;
            lastRowSummary.leaveAmountEvent += employee.deductLeaveEvent;
            lastRowSummary.absent += employee.totalAbsent;
            lastRowSummary.absentAmount += employee.deductAbsent;
            lastRowSummary.absentEvent += employee.totalAbsentEvent;
            lastRowSummary.absentAmountEvent += employee.deductAbsentEvent;
            lastRowSummary.lateAmount += employee.deductLate;
            lastRowSummary.totalLate += employee.totalLate;
            lastRowSummary.totalOB += employee.totalOutbefore;
            lastRowSummary.outBeforTimeAmount += employee.deductOutbefore;
            lastRowSummary.insuranceAmount += insuranceAmount;
            lastRowSummary.vatAmount += vatAmount;
            lastRowSummary.notCheckInAmount = 0.0;
            lastRowSummary.employeeShirtAmount = 0.0;
            lastRowSummary.advanceAmount = 0.0;
            lastRowSummary.totalAddExpenses += employee.totalAddExpenses;
            lastRowSummary.advancePayment += advancePayment;
            lastRowSummary.deductAmount += employee.totalDeduct;
            lastRowSummary.balanceAmount += employee.totalBalance;
          }
        });

        footerDepartmentHtml = ng.renderGroupFooter(
          groupSummaryReceive,
          groupSummaryExpenses,
          groupSummaryTaxlevel,
          groupSummary,
          groupSummaryOTInc,
          groupSummaryOT,
          groupSummaryAbsent,
          groupSummaryAbsentInc,
          groupSummaryLeave,
          groupSummaryLeaveInc,
          groupSummaryLate,
          groupSummaryLateInc,
          groupSummaryOb,
          groupSummaryObInc,
          ng.ot_rate,
          ng.leave_rate,
          ng.absent_rate,
          ng.late_rate,
          ng.ob_rate,
          false,
          ng.headReceive,
          ng.headExpenses
        );

        ng.bodyHtml += departmentHtml + rowHtml + footerDepartmentHtml;
      }

      var footerHtmlx = ng.renderGroupFooter(
        lastSummaryReceive,
        lastSummaryExpenses,
        lastSummaryTaxlevel,
        lastRowSummary,
        lastSummaryOTInc,
        lastSummaryOT,
        lastSummaryAbsent,
        lastSummaryAbsentInc,
        lastSummaryLeave,
        lastSummaryLeaveInc,
        lastSummaryLate,
        lastSummaryLateInc,
        lastSummaryOb,
        lastSummaryObInc,
        ng.ot_rate,
        ng.leave_rate,
        ng.absent_rate,
        ng.late_rate,
        ng.ob_rate,
        true,
        ng.headReceive,
        ng.headExpenses
      );

      ng.bodyHtml += footerHtmlx;

      this.showbodyhtml = this.bodyHtml;
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    renderNormalRow(
      item,
      craftAmount,
      positionAmount,
      extraAmount,
      insuranceAmount,
      vatAmount,
      advancePayment,
      ot_rate,
      absent_rate,
      leave_rate,
      ob_rate,
      late_rate,
      headReceive,
      headExpenses
    ) {
      let empTypeText = "";
      let ng = this;
      if (
        (item.isResign == false &&
          item.totalWorkDay == 0 &&
          item.isSpecial == true) ||
        (item.isResign == true && item.totalWorkDay > 0) ||
        (item.isResign == false && item.totalWorkDay > 0)
      ) {
        //console.log(item.code)
        switch (item.empType) {
          case 0:
            empTypeText = "รายเดือน";
            break;
          case 1:
            empTypeText = "รายวัน";
            break;
          case 2:
            empTypeText = "รายชั่วโมง";
            break;
          default:
            break;
        }
        let valuex =  item.name.split("(");
        let name =  valuex[0];
        let nickname ="";
        if(valuex[1]!= '' && valuex[1]!= undefined){
         let arrnickname = valuex[1].split(")");
          nickname = arrnickname[0];
        
        }else{
          nickname = "";
        }
        let htmlz =
          `<tr>` +
          `<td nowrap >` +
          item.code +
          `</td>` +
          `<td nowrap  >` +
          name +
           (nickname!= "" ? `(` +nickname +`)</td>` :'') +
          (this.table_head_model.ประเภท == "1" ? `<td nowrap>` + empTypeText + `</td>` : "") +
          (this.table_head_model.ตำแหน่ง == "1"
            ? `<td nowrap>` + item.position + `</td>`
            : "") +
          (this.table_head_model.วันเริ่มทำงาน == "1"
            ? `<td nowrap>` +
              this.selectedformatDates(item.startWorkingDate) +
              `</td>`
            : "");
        if (this.table_head_model.วันทำงานเดือนนี้ == "1") {
          if (item.empType == 0) {
            if (item.isResign || item.isNewbie) {
              htmlz += `<td nowrap>` + item.totalWorkDay + `</td>`;
            } else {
              htmlz += `<td nowrap>` + item.workingDate + `</td>`;
            }
          } else if (item.empType == 2) {
            htmlz += `<td nowrap>` + item.totalWorkhour + ` ชม</td>`;
          } else {
            htmlz += `<td nowrap>` + item.totalWorkDay + `</td>`;
          }
        }
       
        htmlz +=
          (this.table_head_model.เงินเดือน == "1"
            ? `<td nowrap style="text-align:right;">` +
              ng.thousandSep(item.salary) +
              `</td>`
            : "") +
          (this.table_head_model.ค่าฝีมือ == "1"
            ? `<td nowrap style="text-align:right;">` +
              ng.thousandSep(craftAmount) +
              `</td>`
            : "") +
          (this.table_head_model.ค่าตำแหน่ง == "1"
            ? `<td nowrap style="text-align:right;">` +
              ng.thousandSep(positionAmount) +
              `</td>`
            : "");
        if (this.table_head_model.รวมเงินได้ == "1") {
          if (item.empType == 1) {
            if (item.perDay > 0) {
              htmlz +=
                `<td nowrap style="text-align:right;background-color: #B2FF59">` +
                ng.thousandSep(
                  item.perDay * item.totalWorkDay + craftAmount + positionAmount
                ) +
                `</td>`;
            } else {
              htmlz +=
                `<td nowrap style="text-align:right;background-color: #B2FF59">` +
                ng.thousandSep(item.totalByDayEarning) +
                `</td>`;
            }
          } else if (item.empType == 2) {
            if (item.perHour > 0) {
              htmlz +=
                `<td nowrap style="text-align:right;background-color: #B2FF59">` +
                ng.thousandSep(
                  item.perHour * item.totalWorkhour +
                    craftAmount +
                    positionAmount
                ) +
                `</td>`;
            } else {
              htmlz +=
                `<td nowrap style="text-align:right;background-color: #B2FF59">` +
                ng.thousandSep(item.totalEarningTypeHours) +
                ` <span class='fa fa-search earningdetail' role='button' code='` +
                item.code +
                `'></span></td>`;
            }
          } else {
            if (item.isResign || item.isNewbie) {
              htmlz +=
                `<td nowrap style="text-align:right;background-color: #B2FF59">` +
                ng.thousandSep(item.perDay * item.totalWorkDay) +
                `</td>`;
            } else {
              htmlz +=
                `<td nowrap style="text-align:right;background-color: #B2FF59">` +
                ng.thousandSep(item.salary + craftAmount + positionAmount) +
                `</td>`;
            }
          }
        }

        htmlz +=
          this.table_head_model.วันละ == "1"
            ? `<td nowrap style="text-align:right;">` +
              ng.thousandSep(item.perDay) +
              `</td>`
            : "";
        htmlz +=
          this.table_head_model.ชั่วโมงละ == "1"
            ? `<td nowrap style="text-align:right;">` +
              ng.thousandSep(item.perHour) +
              `</td>`
            : "";

        for (var i = 0; i < ot_rate.length; i++) {
          var value = 0;
          var ottime = 0;
          let rowz = item.processTimes.filter(c => c.ot_rate == ot_rate[i]);
          for (var v = 0; v < rowz.length; v++) {
            value += parseFloat(rowz[v].ot_by_date);
            ottime += parseFloat(rowz[v].total_ottime);
          }

          htmlz += this.table_head_model.เวลาเข้างาน == "1" ?
            `<td nowrap style="text-align:right;">` +
            ng.thousandSep(ottime) +
            `</td>`:"";
          htmlz += this.table_head_model.เวลาเข้างาน == "1" ?
            `<td nowrap style="text-align:right;">` +
            ng.thousandSep(value) +
            `</td>`:"";
        }

        htmlz +=
          this.table_head_model.ชม_OT_รวม == "1"
            ? `<td nowrap style="text-align:right;background-color: #81D4FA">` +
              ng.thousandSep(item.totalOT) +
              `</td>`
            : "";
        htmlz +=
          this.table_head_model.เงิน_OT_รวม == "1"
            ? `<td nowrap style="text-align:right;background-color: #81D4FA">` +
              ng.thousandSep(item.otEarning) +
              `</td>`
            : "";

        if (this.table_head_model.รวมรายรับอื่นๆ == "1") {
          if (this.table_head_model.รายละเอียดรายรับ == "1") {
            for (let i = 0; i < headReceive.length; i++) {
              let value = 0;
              let rowz = item.incomeAndExpenses.filter(
                c => c.name == headReceive[i] && c.tranFlag == 0
              );
              for (let v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].amount);
              }
              htmlz +=
                `<td nowrap class="subDetail" style="text-align:right;background-color:#D1C4E9" >` +
                ng.thousandSep(value) +
                `</td>`;
            }
          }
          htmlz +=
            `<td nowrap style="text-align:right;background-color:#D1C4E9">` +
            ng.thousandSep(item.totalAddIncome) +
            `</td>`;
        }
        htmlz +=
          this.table_head_model.วันหยุดพิเศษ == "1"
            ? `<td nowrap style="text-align:right;background-color: #B9F6CA">` +
              item.holidaywork +
              `</td>`
            : "";
        htmlz +=
          this.table_head_model.รายได้วันหยุดพิเศษ == "1"
            ? `<td nowrap style="text-align:right;background-color: #B9F6CA">` +
              ng.thousandSep(item.holidayworkearning) +
              `</td>`
            : "";
        htmlz +=
          this.table_head_model.รวมรายได้ == "1"
            ? `<td nowrap style="text-align:right;background-color: #B2FF59">` +
              ng.thousandSep(item.totalEarning) +
              `</td>`
            : "";

        for (var i = 0; i < leave_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter(
            c => c.deduct_leave_rate == leave_rate[i]
          );
          for (var v = 0; v < rowz.length; v++) {
            //console.log(leave_rate[i] + " : " + parseFloat(rowz[v].deduct_leave_by_date))
            value += parseFloat(rowz[v].deduct_leave_by_date);
            time += parseFloat(rowz[v].total_leavetime);
          }
          //console.log(value)

          htmlz += this.table_head_model.เวลาเข้างาน == "1" ?
            `<td nowrap style="text-align:right;">` +
            ng.thousandSep(time) +
            `</td>
            <td nowrap style="text-align:right;">` +
            ng.thousandSep(value) +
            `</td>`:"";
        }

        htmlz +=
          this.table_head_model.ชม_ลา_รวม == "1"
            ? `<td nowrap style="text-align:right;background-color: #FFB74D">` +
              ng.thousandSep(item.totalLeave) +
              `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักเงินลา_รวม == "1"
            ? `<td nowrap style="text-align:right;background-color: #FFB74D">` +
              ng.thousandSep(item.deductLeave) +
              `</td>`
            : "";
        htmlz +=
          this.table_head_model.ลาไม่หักเงิน == "1"
            ? `<td nowrap style="text-align:right;background-color: #FFF">` +
              ng.thousandSep(item.totalLeaveUncut) +
              `</td>`
            : "";

        for (var i = 0; i < absent_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter(
            c => c.deduct_absent_rate == absent_rate[i]
          );
          for (var v = 0; v < rowz.length; v++) {
            //console.log(ot_rate[i] + " : " + parseFloat(rowz[v].ot_by_date))
            value += parseFloat(rowz[v].deduct_absent_by_date);
            time += parseFloat(rowz[v].total_absenttime);
          }
          //console.log(value)

          htmlz += this.table_head_model.เวลาเข้างาน == "1" ?
            `<td nowrap style="text-align:right;">` +
            ng.thousandSep(time) +
            `</td>
            <td nowrap style="text-align:right;">` +
            ng.thousandSep(value) +
            `</td>`:"";
        }
        htmlz +=
          this.table_head_model.ชม_ขาด_รวม == "1"
            ? `<td nowrap style="text-align:right;background-color: #EF5350">` +
              ng.thousandSep(item.totalAbsent) +
              `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักเงินขาด_รวม == "1"
            ? `<td nowrap style="text-align:right;background-color: #EF5350">` +
              ng.thousandSep(item.deductAbsent) +
              `</td>`
            : "";

        for (var i = 0; i < late_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter(
            c => c.deduct_late_rate == late_rate[i]
          );
          for (var v = 0; v < rowz.length; v++) {
            //console.log(ot_rate[i] + " : " + parseFloat(rowz[v].ot_by_date))
            value += parseFloat(rowz[v].deduct_late_by_date);
            time += parseFloat(rowz[v].total_latetime);
          }
          //console.log(value)

          htmlz += this.table_head_model.เวลาเข้างาน == "1" ?
            `<td nowrap style="text-align:right;">` +
            ng.thousandSep(time) +
            `</td>
            <td nowrap style="text-align:right;">` +
            ng.thousandSep(value) +
            `</td>`:"";
        }
        htmlz +=
          this.table_head_model.สาย_รวม == "1"
            ? `<td nowrap style="text-align:right;background-color: #A7FFEB">` +
              ng.thousandSep(item.totalLate) +
              `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักเงินสาย_รวม == "1"
            ? `<td nowrap style="text-align:right;background-color: #A7FFEB">` +
              ng.thousandSep(item.deductLate) +
              `</td>`
            : "";

        for (var i = 0; i < ob_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter(
            c => c.deduct_ob_rate == ob_rate[i]
          );
          for (var v = 0; v < rowz.length; v++) {
            //console.log(ot_rate[i] + " : " + parseFloat(rowz[v].ot_by_date))
            value += parseFloat(rowz[v].deduct_ob_by_date);
            time += parseFloat(rowz[v].total_out_before_time);
          }
          //console.log(value)

          htmlz += this.table_head_model.เวลาเข้างาน == "1" ?
            `<td nowrap style="text-align:right;">` +
            ng.thousandSep(time) +
            `</td>
            <td nowrap style="text-align:right;">` +
            ng.thousandSep(value) +
            `</td>`:"";
        }
        htmlz +=
          this.table_head_model.ออกก่อน_รวม == "1"
            ? `<td nowrap style="text-align:right;background-color: #E6EE9C">` +
              ng.thousandSep(item.totalOutbefore) +
              `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักออกก่อน_รวม == "1"
            ? `<td nowrap style="text-align:right;background-color: #E6EE9C">` +
              ng.thousandSep(item.deductOutbefore) +
              `</td>`
            : "";
        htmlz +=
          this.table_head_model.ประกันสังคม == "1"
            ? `<td nowrap style="text-align:right;background-color: #FFF">` +
              ng.thousandSep(insuranceAmount) +
              `</td>`
            : "";

        if (this.table_head_model.ภาษี == "1") {
          // if (vatAmount > 0) {
          //   htmlz +=
          //     `<td nowrap style="text-align:right;">` +
          //     ng.thousandSep(vatAmount) +
          //     `<i class="fa fa-search btn-TaxDetail" role="button" code="` +
          //     item.code +
          //     `"></i></td>`;
          // } else {
          htmlz +=
            `<td nowrap style="text-align:right;">` +
            ng.thousandSep(vatAmount) +
            `</td>`;
          // }
        }

        if (this.table_head_model.รวมรายจ่ายอื่นๆ == "1") {
          if (this.table_head_model.รายละเอียดรายจ่าย == "1") {
            for (var i = 0; i < headExpenses.length; i++) {
              var value = 0;

              let rowz = item.incomeAndExpenses.filter(
                c => c.name == headExpenses[i] && c.tranFlag == 1
              );
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].amount);
              }

              htmlz +=
                `
            <td nowrap style="text-align:right;background-color:#FFCCBC" class="subDetail">` +
                ng.thousandSep(value) +
                `</td>`;
            }
          }
          htmlz +=
            `<td nowrap style="text-align:right;background-color: #FFCCBC">` +
            ng.thousandSep(item.totalAddExpenses) +
            `</td>`;
        }

        htmlz +=
          this.table_head_model.รวมหัก == "1"
            ? `<td nowrap style="text-align:right;background-color: #FFAB91">` +
              ng.thousandSep(item.totalDeduct) +
              `</td>`
            : "";

        if (this.table_head_model.คงเหลือเงิน == "1") {
          if (item.totalBalance < 0) {
            htmlz += `<td nowrap style="text-align:right;">0.0</td>`;
          } else {
            htmlz +=
              `<td nowrap style="text-align:right;background-color: #B2FF59">` +
              ng.thousandSep(item.totalBalance) +
              `</td>`;
          }
        }

        if (
          this.table_head_model.ประเภทการจ่ายเงิน == "1" &&
          this.table_head_model.เลขที่บัญชี == "1"
        ) {
          if (item.paymentType == 0) {
            htmlz +=
              `<td nowrap style="text-align:left;">` + item.bankName + `</td>`;
            htmlz +=
              `<td nowrap style="text-align:left;">` + item.bankCode + `</td>`;
          } else if (item.paymentType == 1) {
            htmlz += `<td nowrap style="text-align:left;">พร้อมเพย์</td>`;
            htmlz +=
              `<td nowrap style="text-align:left;">` +
              item.promptpayNumber +
              `</td>`;
          } else if (item.paymentType == 2) {
            htmlz += `<td nowrap style="text-align:left;">เงินสด</td>`;
            htmlz += `<td nowrap style="text-align:left;"></td>`;
          } else {
            htmlz += `<td nowrap style="text-align:left;">อื่นๆ</td>`;
            htmlz += `<td nowrap style="text-align:left;"></td>`;
          }
        }
        if( this.table_head_model.เวลาเข้างาน == "1"){

        }

        htmlz += `</tr>`;

        return htmlz;
      }
    },
    renderGroupFooter(
      groupSummaryReceive,
      groupSummaryExpenses,
      groupSummaryTaxlevel,
      groupSummary,
      groupSummaryOTInc,
      groupSummaryOT,
      groupSummaryAbsent,
      groupSummaryAbsentInc,
      groupSummaryLeave,
      groupSummaryLeaveInc,
      groupSummaryLate,
      groupSummaryLateInc,
      groupSummaryOb,
      groupSummaryObInc,
      ot_rate,
      leave_rate,
      absent_rate,
      late_rate,
      ob_rate,
      isLastRow,
      headReceive,
      headExpenses
    ) {
      var html = "";
      let ng = this;
      html +=
        `<tr style="background-color:` +
        (isLastRow ? "#5AC594" : "#dff0d8") +
        `">`;
      if (isLastRow) {
            html += `<td nowrap  colspan='2'>รวมทั้งหมด</td>`;
      } else {
            html += `<td nowrap  colspan='2'>รวม</td>`;
      }
      let table_head = 0;
          if (this.table_head_model.ประเภท == "1") {
              table_head += 1;
            }
          if (this.table_head_model.วันทำงานเดือนนี้ == "1") {
              table_head += 1;
            }
          if (this.table_head_model.ตำแหน่ง == "1") {
              table_head += 1;
            }
          if (this.table_head_model.วันเริ่มทำงาน == "1") {
              table_head += 1;    
      }
      if (this.table_head_count > 1) {
        if (this.table_head_count <= 3) {
          html += "<td nowarp colspan='" + this.table_head_count + "'></td>";
        } else {
          console.log("tableeeee:",table_head)
          if(table_head != 0){
              html += "<td nowarp colspan='" + table_head + "'></td>";
          }
          else{

          }
          
        }
        // html += `<td nowrap colspan=''></td> <td nowrap></td> <td nowrap></td>`;
      }
      html +=
        this.table_head_model.เงินเดือน == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.salary) +
            `</td>`
          : "";
      html +=
        this.table_head_model.ค่าฝีมือ == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.craftAmount) +
            `</td>`
          : "";
      html +=
        this.table_head_model.ค่าตำแหน่ง == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.positionAmount) +
            `</td>`
          : "";
      html +=
        this.table_head_model.รวมเงินได้ == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.incomeBeforeExtraAndOT) +
            `</td>`
          : "";
      html +=
        this.table_head_model.วันละ == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.perDay) +
            `</td>`
          : "";
      html +=
        this.table_head_model.ชั่วโมงละ == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.perHour) +
            `</td>`
          : "";
       if(this.table_head_model.เวลาเข้างาน == "1"){
      for (var s = 0; s < ot_rate.length; s++) {
        html +=
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummaryOT[s]) +
          `</td>`;
        html +=
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummaryOTInc[s]) +
          `</td>`;
      }
       }
      html +=
        this.table_head_model.ชม_OT_รวม == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.OT) +
            `</td>`
          : "";
      html +=
        this.table_head_model.เงิน_OT_รวม == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.OTAmount) +
            `</td>`
          : "";

      if (this.table_head_model.รวมรายรับอื่นๆ == "1") {
        if (this.table_head_model.รายละเอียดรายรับ) {
          for (var s = 0; s < headReceive.length; s++) {
         if(groupSummaryReceive[s] != '' && groupSummaryReceive[s] !=undefined){
           html +=
              `<td nowrap class="subDetail" style="text-align:right;">` +
              ng.thousandSep(groupSummaryReceive[s]) +
              `</td>`;
         }else{
           
           html +=
              `<td nowrap class="subDetail" style="text-align:right;">` +
              ng.thousandSep(0) +
              `</td>`;
         
         }
            
          }
        }
        html +=
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummary.totalAddIncome) +
          `</td>`;
      }

      html +=
        this.table_head_model.วันหยุดพิเศษ == "1"
          ? `<td nowrap style="text-align:right;">` +
            groupSummary.extraHoliday +
            `</td>`
          : "";
      html +=
        this.table_head_model.รายได้วันหยุดพิเศษ == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.extraHolidayAmount) +
            `</td>`
          : "";
      html +=
        this.table_head_model.รวมรายได้ == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.incomeBeforeExpenses) +
            `</td>`
          : "";
       if(this.table_head_model.เวลาเข้างาน == "1"){
      for (var s = 0; s < leave_rate.length; s++) {
        if(groupSummaryLeave[s] != '' && groupSummaryLeave[s] != undefined){
           html += this.table_head_model.เวลาเข้างาน == "1" ?
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummaryLeave[s]) +
          `</td>`:"";
        }else{
           html += this.table_head_model.เวลาเข้างาน == "1" ?
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(0) +
          `</td>`:"";
        }
        if(groupSummaryLeaveInc[s] != ''&& groupSummaryLeaveInc[s] != undefined){
          html += this.table_head_model.เวลาเข้างาน == "1" ?
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummaryLeaveInc[s]) +
          `</td>`:"";
        }else{
           html += this.table_head_model.เวลาเข้างาน == "1" ?
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(0) +
          `</td>`:"";
        }
      }
      }
      html +=
        this.table_head_model.ชม_ลา_รวม == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.leave) +
            `</td>`
          : "";
      html +=
        this.table_head_model.หักเงินลา_รวม == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.leaveAmount) +
            `</td>`
          : "";
      html +=
        this.table_head_model.ลาไม่หักเงิน == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.leaveUncut) +
            `</td>`
          : "";
       if(this.table_head_model.เวลาเข้างาน == "1"){
      for (var s = 0; s < absent_rate.length; s++) {
        html += this.table_head_model.เวลาเข้างาน == "1" ?
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummaryAbsent[s]) +
          `</td>`:"";
        html += this.table_head_model.เวลาเข้างาน == "1" ?
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummaryAbsentInc[s]) +
          `</td>`:" ";
      }
       }
      html +=
        this.table_head_model.ชม_ขาด_รวม == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.absent) +
            `</td>`
          : "";
      html +=
        this.table_head_model.หักเงินขาด_รวม == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.absentAmount) +
            `</td>`
          : "";
 if(this.table_head_model.เวลาเข้างาน == "1"){
      for (var s = 0; s < late_rate.length; s++) {
        html += this.table_head_model.เวลาเข้างาน == "1" ?
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummaryLate[s]) +
          `</td>`:"";
        html += this.table_head_model.เวลาเข้างาน == "1" ?
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummaryLateInc[s]) +
          `</td>`:"";
      }
 }
      html +=
        this.table_head_model.สาย_รวม == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.totalLate) +
            `</td>`
          : "";
      html +=
        this.table_head_model.หักเงินสาย_รวม == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.lateAmount) +
            `</td>`
          : "";
    if(this.table_head_model.เวลาเข้างาน == "1"){
      for (var s = 0; s < ob_rate.length; s++) {
        html += this.table_head_model.เวลาเข้างาน == "1" 
                  ? `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummaryOb[s]) +
          `</td>`:"";
        html +=
        this.table_head_model.เวลาเข้างาน == "1"
          ? `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummaryObInc[s]) +
          `</td>`:"";
      }
    }

      html +=
        this.table_head_model.ออกก่อน_รวม == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.totalOB) +
            `</td>`
          : "";
      html +=
        this.table_head_model.หักออกก่อน_รวม == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.outBeforTimeAmount) +
            `</td>`
          : "";
      html +=
        this.table_head_model.ประกันสังคม == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.insuranceAmount) +
            `</td>`
          : "";
 if(this.table_head_model.เวลาเข้างาน == "1"){
      for (var u = 0; u < groupSummaryTaxlevel.length; u++) {
        // console.log(groupSummaryTaxlevel[u]);
        html +=
          `   <td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummaryTaxlevel[u]) +
          `</td>`;
      }
 }
      html +=
        this.table_head_model.ภาษี == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.vatAmount) +
            `</td>`
          : "";

      if (this.table_head_model.รวมรายจ่ายอื่นๆ == "1") {
        if (this.table_head_model.รายละเอียดรายจ่าย == "1") {
          for (var s = 0; s < headExpenses.length; s++) {
            if(groupSummaryExpenses[s] !=''&& groupSummaryExpenses[s]!= undefined){
              html +=
              `<td nowrap class="subDetail" style="text-align:right;">` +
              ng.thousandSep(groupSummaryExpenses[s]) +
              `</td>`;
            }else{
              html +=
              `<td nowrap class="subDetail" style="text-align:right;">` +
              ng.thousandSep(0) +
              `</td>`;
            }
            
          }
        }
        html +=
          `<td nowrap style="text-align:right;">` +
          ng.thousandSep(groupSummary.totalAddExpenses) +
          `</td>`;
      }

      html +=
        this.table_head_model.รวมหัก == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.deductAmount) +
            `</td>`
          : "";
      html +=
        this.table_head_model.คงเหลือเงิน == "1"
          ? `<td nowrap style="text-align:right;">` +
            ng.thousandSep(groupSummary.balanceAmount) +
            `</td>`
          : "";
      html +=
        this.table_head_model.ประเภทการจ่ายเงิน == "1"
          ? `<td nowrap></td>`
          : "";
      html +=
        this.table_head_model.เลขที่บัญชี == "1" ? `<td nowrap></td>` : "";
      html += "</tr>";

      return html;
    },
    renderDepartment(
      departmentName,
      ot_rate,
      absent_rate,
      leave_rate,
      ob_rate,
      late_rate,
      item,
      headReceive,
      headExpenses
    ) {
      let ng = this;
      let headcount = this.table_head_count;
      if(this.table_head_model.เวลาเข้างาน == "1"){
        ot_rate.forEach(element => {
        headcount += 2;
        });
        absent_rate.forEach(element => {
          headcount += 2;
        });
        leave_rate.forEach(element => {
          headcount += 2;
        });
        ob_rate.forEach(element => {
          headcount += 2;
        });
        late_rate.forEach(element => {
          headcount += 2;
        });
      }
     
      let html = "";
      
      html=" ";
      html += `<tr style="background-color:#fcf8e3">`;
      html += `<td nowrap colspan='2'>` + departmentName + `</td>`;

      for (var i = 0; i < (headcount == 1 ? headcount : headcount - 1); i++
      ) {
        html += `<td style="border-left:0px;border-right:0px;"></td>`;
      }
    if (this.table_head_model.รวมรายรับอื่นๆ == "1") {
      if(headReceive.length > 0){
        headReceive.forEach(element => {
            html += `<td style="border-left:0px;border-right:0px;" class="subDetail"></td>`;
        });
      }
      else{
        // html += `<td style="border-left:0px;border-right:0px;" class="subDetail"></td>`;
      }
    }
     if (this.table_head_model.รวมรายจ่ายอื่นๆ == "1") {
       if(headExpenses.length > 0){
            headExpenses.forEach(element => {
             html += `<td style="border-left:0px;border-right:0px;" class="subDetail"></td>`;
          });
       }
        else{
        // html += `<td style="border-left:0px;border-right:0px;" class="subDetail"></td>`;
      }
     }
      html += `</tr>`;
      headcount = 0;
      return html;
    },
    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    renderheader() {
      this.table_head_count = 1;
      let tableheader = "";
      let ng = this;
      tableheader += `<th nowrap >รหัส</th>`;
      tableheader += `<th nowrap >ชื่อ</th>`;
      if (this.table_head_model.ประเภท == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ประเภท</th>`;
      }
      if (this.table_head_model.ตำแหน่ง == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ตำแหน่ง</th>`;
      }
      if (this.table_head_model.วันเริ่มทำงาน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap class="text-center">วันเริ่มทำงาน</th>`;
      }
      if (this.table_head_model.วันทำงานเดือนนี้ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap class="text-center">วันทำงาน<br>เดือนนี้</th>`;
      }
      if (this.table_head_model.เงินเดือน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>เงินเดือน</th>`;
      }
      if (this.table_head_model.ค่าฝีมือ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ค่าฝีมือ</th>`;
      }
      if (this.table_head_model.ค่าตำแหน่ง == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ค่าตำแหน่ง</th>`;
      }
      if (this.table_head_model.รวมเงินได้ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รวมเงินได้</th>`;
      }
      if (this.table_head_model.วันละ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>วันละ</th>`;
      }
      if (this.table_head_model.ชั่วโมงละ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชั่วโมงละ</th>`;
      }
      if(this.table_head_model.เวลาเข้างาน == "1"){
        for (var i = 0; i < this.ot_rate.length; i++) {
                tableheader +=
                  `<th nowrap >OT ` +
                  this.ot_rate[i] +
                  `</th> <th nowrap >เงินOT ` +
                  this.ot_rate[i] +
                  `</th>`;
              }
      }
      

      if (this.table_head_model.ชม_OT_รวม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชม.OT รวม</th>`;
      }
      if (this.table_head_model.เงิน_OT_รวม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>เงิน OT รวม</th>`;
      }
      if (this.table_head_model.รวมรายรับอื่นๆ == "1") {
        this.table_head_count += 1;
        if (this.table_head_model.รายละเอียดรายรับ) {
          for (var i = 0; i < this.headReceive.length; i++) {
            this.table_head_count += 1;
            tableheader +=
              `<th nowrap class="text-center subDetail" >` +
              this.headReceive[i] +
              `</th>`;
          }
        }
        tableheader += `<th nowrap>รวมรายรับอื่นๆ</th>`;
      }

      if (this.table_head_model.วันหยุดพิเศษ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>วันหยุดพิเศษ</th>`;
      }
      if (this.table_head_model.รายได้วันหยุดพิเศษ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รายได้วันหยุดพิเศษ</th>`;
      }
      if (this.table_head_model.รวมรายได้ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รวมรายได้</th>`;
      }
      if(this.table_head_model.เวลาเข้างาน == "1"){
      for (var i = 0; i < this.leave_rate.length; i++) {
        tableheader +=
          `<th nowrap >ลา ` +
          this.leave_rate[i] +
          `</th> <th nowrap >หักเงินลา ` +
          this.leave_rate[i] +
          `</th>`;
      }
      }
      if (this.table_head_model.ชม_ลา_รวม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชม.ลา รวม</th>`;
      }
      if (this.table_head_model.หักเงินลา_รวม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักเงินลา รวม</th>`;
      }
      if (this.table_head_model.ลาไม่หักเงิน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ลาไม่หักเงิน (ชม.)</th>`;
      }
      if(this.table_head_model.เวลาเข้างาน == "1"){
      for (var i = 0; i < this.absent_rate.length; i++) {
        tableheader +=
          `<th nowrap >ขาด ` +
          this.absent_rate[i] +
          `</th> <th nowrap >หักเงินขาด ` +
          this.absent_rate[i] +
          `</th>`;
      }
      }

      if (this.table_head_model.ชม_ขาด_รวม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชม.ขาด รวม</th>`;
      }
      if (this.table_head_model.หักเงินขาด_รวม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักเงินขาด รวม</th>`;
      }
     if(this.table_head_model.เวลาเข้างาน == "1"){
      for (var i = 0; i < this.late_rate.length; i++) {
        tableheader +=
          `<th nowrap >สาย ` +
          this.late_rate[i] +
          `</th> <th nowrap >หักเงินสาย ` +
          this.late_rate[i] +
          `</th>`;
      }
      }

      if (this.table_head_model.สาย_รวม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>สาย รวม</th>`;
      }

      if (this.table_head_model.หักเงินสาย_รวม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักเงินสาย รวม</th>`;
      }
    if(this.table_head_model.เวลาเข้างาน == "1"){
      for (var i = 0; i < this.ob_rate.length; i++) {
        tableheader +=
          `<th nowrap >ออกก่อน ` +
          this.ob_rate[i] +
          `</th> <th nowrap >หักออกก่อน ` +
          this.ob_rate[i] +
          `</th>`;
      }
    }
      if (this.table_head_model.ออกก่อน_รวม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ออกก่อน รวม</th>`;
      }
      if (this.table_head_model.หักออกก่อน_รวม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักออกก่อน รวม</th>`;
      }
      if (this.table_head_model.ประกันสังคม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ประกันสังคม</th>`;
      }
      tableheader +=
        this.table_head_model.ภาษี == "1" ? `<th nowrap>ภาษี</th>` : "";

      if (this.table_head_model.รวมรายจ่ายอื่นๆ == "1") {
        this.table_head_count += 1;
        if (this.table_head_model.รายละเอียดรายจ่าย == "1") {
          for (var i = 0; i < this.headExpenses.length; i++) {
            this.table_head_count += 1;
            tableheader +=
              `<th nowrap class="text-center subDetail" >` +
              this.headExpenses[i] +
              `</th>`;
          }
        }
        tableheader += `<th nowrap>รวมรายจ่ายอื่นๆ</th>`;
      }

      if (this.table_head_model.รวมหัก == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รวมหัก</th>`;
      }

      if (this.table_head_model.คงเหลือเงิน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>คงเหลือเงิน</th>`;
      }

      if (this.table_head_model.ประเภทการจ่ายเงิน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ประเภทการจ่ายเงิน</th>`;
      }
      if (this.table_head_model.เลขที่บัญชี == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>เลขที่บัญชี</th>`;
      }
      console.log("header",this.table_head_count)
      this.showheadhtml = tableheader;
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    doCopyTable() {
      let el = document.getElementById("table_detail");
      let body = document.body;
      let range;
      let sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
      }
      document.execCommand("Copy");
      alert("Copy Table to Clipboard");
    },
    doToggleHeader(status) {
      this.table_head_model = {
        ประเภท: status,
        ตำแหน่ง: status,
        วันเริ่มทำงาน: status,
        วันทำงานเดือนนี้: status,
        เงินเดือน: status,
        ค่าฝีมือ: status,
        ค่าตำแหน่ง: status,
        รวมเงินได้: status,
        วันละ: status,
        ชั่วโมงละ: status,
        ชม_OT_รวม: status,
        เงิน_OT_รวม: status,
        รายละเอียดรายรับ: status,
        รวมรายรับอื่นๆ: status,
        วันหยุดพิเศษ: status,
        รายได้วันหยุดพิเศษ: status,
        รวมรายได้: status,
        ชม_ลา_รวม: status,
        หักเงินลา_รวม: status,
        ลาไม่หักเงิน: status,
        ชม_ขาด_รวม: status,
        หักเงินขาด_รวม: status,
        สาย_รวม: status,
        หักเงินสาย_รวม: status,
        ออกก่อน_รวม: status,
        หักออกก่อน_รวม: status,
        ประกันสังคม: status,
        ภาษี: status,
        รายละเอียดรายจ่าย: status,
        รวมรายจ่ายอื่นๆ: status,
        รวมหัก: status,
        คงเหลือเงิน: status,
        ประเภทการจ่ายเงิน: status,
        เลขที่บัญชี: status,
        เวลาเข้างาน:status,
      };
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then(res => {
          this.branch_items = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      SettingService.getProfileDepartmentList()
        .then(res => {
          this.department_items = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.name;
      this.delDialog.emp_code = data.firstName + " " + data.lastName;
      this.delDialog.date = data.add_date;
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteExpenses(this.delDialog.roworder)
        .then(res => {
          this.delDialogStatus = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    },
    // แสดงตารางก่อน download
    checkbutton(buttonlist, type) {
      if (buttonlist == 1 && type == "display") {
        this.buttonlist = 1;
        console.log("table");
      } else if (buttonlist == 0 && type == "display") {
        this.buttonlist = 0;
        console.log("list");
      } else if (buttonlist == 1 && type == "downloadexcel") {
        this.buttonlist = 1;
        setTimeout(() => {
          this.checkstatus("downloadexcel");
        }, 300);
        console.log("downloadexcel");
      } else if (buttonlist == 1 && type == "doCopyTable") {
        this.buttonlist = 1;
        setTimeout(() => {
          this.checkstatus("doCopyTable");
        }, 300);
        console.log("doCopyTable");
      }
    },

    checkstatus(type) {
      let v = this;
      if (type == "downloadexcel") {
        v.downloadexcel();
      }
      if (type == "doCopyTable") {
        v.doCopyTable();
      }
    }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,
h3,
span,
p {
  font-family: "Prompt", sans-serif;
}
.border {
  border: 1px black solid;
}
.scroll-area {
  position: relative;
  width: 100%;
  height: 440px;
  margin-bottom: 30px;
}

/* mobile  ----------- */
@media screen and (min-width: 320px) and (max-width: 640px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* tablet  ----------- */
@media screen and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

@media screen and (min-width: 1024px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1020px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
@media only screen and (min-device-width: 772px) and (max-device-width: 1020px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
</style>
